var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataManagementHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 434,
    viewBox: "0 0 528 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4079 414.603L19.1432 401.211C25.5818 397.52 33.9948 395.631 42.4079 395.631C50.8209 395.631 59.234 397.52 65.6725 401.211C72.1111 404.903 75.2874 409.796 75.2874 414.603C75.2874 419.497 72.1111 424.304 65.6725 427.996C59.234 431.687 50.8209 433.576 42.4079 433.576C33.9948 433.576 25.5818 431.687 19.1432 427.996C12.7047 424.304 9.52832 419.411 9.52832 414.603H42.4079Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52832 414.603C9.52832 409.71 12.7047 404.903 19.1432 401.211L42.4079 414.603H9.52832Z",
    fill: "#C0162E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M476.71 286.176L495.253 301.542L518.174 288.322C506.928 281.798 489.33 281.025 476.71 286.176Z",
    fill: "#C0162E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M518.174 288.322L495.253 301.543L525.3 294.417C523.668 292.185 521.351 290.125 518.174 288.322Z",
    fill: "#59595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M495.253 301.542L476.71 286.176C475.165 286.777 473.705 287.463 472.332 288.322C465.979 292.013 462.803 296.735 462.803 301.542C462.803 306.35 465.979 311.157 472.332 314.763C485.037 322.06 505.555 322.06 518.26 314.763C524.184 311.329 527.36 306.865 527.703 302.401C527.875 299.74 527.102 296.993 525.3 294.417L495.253 301.542Z",
    fill: "#292929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.361 242.308L96.4075 238.273L94.8622 237.328L93.2312 238.273L92.0293 238.959L93.6604 239.904L94.8622 239.217L101.73 243.252L103.361 242.308Z",
    fill: "#59595B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.542 235.268L106.709 233.637C105.078 232.693 105.078 231.147 106.709 230.117C108.34 229.173 111.087 229.173 112.718 230.117L115.551 231.748C117.182 232.693 117.182 234.238 115.551 235.268C113.92 236.212 111.173 236.212 109.542 235.268ZM108.34 232.693L111.173 234.324C111.945 234.753 113.233 234.753 114.006 234.324C114.778 233.895 114.778 233.122 114.006 232.693L111.173 231.062C110.4 230.632 109.112 230.632 108.34 231.062C107.567 231.491 107.567 232.178 108.34 232.693Z",
    fill: "#C0162E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.525 233.809L77.6921 232.178C76.061 231.233 76.061 229.688 77.6921 228.658C79.3232 227.714 82.0703 227.714 83.7014 228.658L86.5344 230.289C88.1655 231.233 88.1655 232.779 86.5344 233.809C84.9033 234.753 82.242 234.753 80.525 233.809ZM79.3232 231.233L82.1561 232.864C82.9288 233.294 84.2165 233.294 84.9891 232.864C85.7617 232.435 85.7617 231.663 84.9891 231.233L82.1561 229.602C81.3835 229.173 80.0958 229.173 79.3232 229.602C78.5506 230.032 78.5506 230.804 79.3232 231.233Z",
    fill: "#C0162E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7457 226.168L90.9128 224.537C89.2817 223.593 89.2817 222.048 90.9128 221.018C92.5439 220.073 95.291 220.073 96.9221 221.018L99.7551 222.649C101.386 223.593 101.386 225.138 99.7551 226.168C98.124 227.113 95.4627 227.113 93.7457 226.168ZM92.5439 223.593L95.3768 225.224C96.1495 225.653 97.4372 225.653 98.2098 225.224C98.9824 224.795 98.9824 224.022 98.2098 223.593L95.3768 221.962C94.6042 221.533 93.3165 221.533 92.5439 221.962C91.7712 222.391 91.7712 223.164 92.5439 223.593Z",
    fill: "#C0162E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M114.092 217.927L107.138 213.892L105.507 212.948L103.962 213.892L102.76 214.579L104.391 215.523L105.507 214.837L112.461 218.871L114.092 217.927Z",
    fill: "#59595B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8543 224.108L64.9865 220.073L63.3554 219.129L61.7243 220.073L60.5225 220.76L62.1536 221.704L63.3554 221.018L70.3091 225.052L71.8543 224.108Z",
    fill: "#59595B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0358 217.069L75.2028 215.437C73.5717 214.493 73.5717 212.948 75.2028 211.918C76.8339 210.973 79.581 210.973 81.2121 211.918L84.0451 213.549C85.6762 214.493 85.6762 216.038 84.0451 217.069C82.414 218.013 79.6669 218.013 78.0358 217.069ZM76.8339 214.493L79.6669 216.124C80.4395 216.553 81.7272 216.553 82.4998 216.124C83.2725 215.695 83.2725 214.922 82.4998 214.493L79.6669 212.862C78.8943 212.433 77.6065 212.433 76.8339 212.862C76.0613 213.291 76.0613 214.064 76.8339 214.493Z",
    fill: "#C0162E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3817 208.827L91.428 204.792L89.7969 203.848L88.1658 204.792L87.0498 205.479L88.5951 206.423L89.7969 205.737L96.7506 209.771L98.3817 208.827Z",
    fill: "#59595B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 201.187L104.648 197.152L103.017 196.208L101.386 197.152L100.27 197.839L101.901 198.783L103.017 198.096L109.97 202.131L111.601 201.187Z",
    fill: "#59595B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1051 215.609L46.2722 213.978C44.6411 213.034 44.6411 211.489 46.2722 210.458C47.9033 209.514 50.6504 209.514 52.2815 210.458L55.1144 212.089C56.7455 213.034 56.7455 214.579 55.1144 215.609C53.3975 216.554 50.7362 216.554 49.1051 215.609ZM47.8174 213.034L50.6504 214.665C51.423 215.094 52.7107 215.094 53.4833 214.665C54.256 214.236 54.256 213.463 53.4833 213.034L50.6504 211.403C49.8777 210.973 48.59 210.973 47.8174 211.403C47.0448 211.832 47.0448 212.605 47.8174 213.034Z",
    fill: "#C0162E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3258 207.969L59.4929 206.338C57.8618 205.393 57.8618 203.848 59.4929 202.818C61.124 201.874 63.8711 201.874 65.5022 202.818L68.3351 204.449C69.9662 205.393 69.9662 206.939 68.3351 207.969C66.704 208.913 63.9569 208.913 62.3258 207.969ZM61.0381 205.393L63.8711 207.024C64.6437 207.454 65.9314 207.454 66.704 207.024C67.4767 206.595 67.4767 205.823 66.704 205.393L63.8711 203.762C63.0985 203.333 61.8107 203.333 61.0381 203.762C60.2655 204.191 60.2655 204.964 61.0381 205.393Z",
    fill: "#C0162E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5858 199.727L75.718 195.778L74.0869 194.834L72.4558 195.778L71.2539 196.379L72.885 197.324L74.0869 196.637L80.9547 200.672L82.5858 199.727Z",
    fill: "#59595B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7663 192.688L85.9333 191.057C84.3022 190.112 84.3022 188.567 85.9333 187.537C87.5644 186.593 90.3115 186.593 91.9426 187.537L94.7756 189.168C96.4067 190.112 96.4067 191.658 94.7756 192.688C93.1445 193.632 90.3974 193.632 88.7663 192.688ZM87.5644 190.112L90.3973 191.744C91.17 192.173 92.4577 192.173 93.2303 191.744C94.0029 191.314 94.0029 190.542 93.2303 190.112L90.3973 188.481C89.6247 188.052 88.337 188.052 87.5644 188.481C86.7918 188.911 86.7918 189.683 87.5644 190.112Z",
    fill: "#C0162E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.987 185.047L99.154 183.416C97.5229 182.472 97.5229 180.927 99.154 179.897C100.785 178.952 103.532 178.952 105.163 179.897L107.996 181.528C109.627 182.472 109.627 184.017 107.996 185.047C106.365 185.992 103.704 185.992 101.987 185.047ZM100.785 182.472L103.618 184.103C104.391 184.532 105.678 184.532 106.451 184.103C107.224 183.674 107.224 182.901 106.451 182.472L103.618 180.841C102.845 180.412 101.558 180.412 100.785 180.841C100.012 181.27 100.012 182.043 100.785 182.472Z",
    fill: "#C0162E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3092 206.509L30.4763 204.878C28.8452 203.934 28.8452 202.389 30.4763 201.358C32.1074 200.414 34.8545 200.414 36.4856 201.358L39.3185 202.989C40.9496 203.934 40.9496 205.479 39.3185 206.509C37.6874 207.454 35.0262 207.454 33.3092 206.509ZM32.1074 203.934L34.9403 205.565C35.7129 205.994 37.0007 205.994 37.7733 205.565C38.5459 205.136 38.5459 204.363 37.7733 203.934L34.9403 202.303C34.1677 201.873 32.88 201.873 32.1074 202.303C31.3347 202.818 31.3347 203.505 32.1074 203.934Z",
    fill: "#C0162E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6551 198.268L46.7015 194.319L45.0704 193.375L43.4393 194.319L42.3232 195.006L43.9543 195.864L45.0704 195.263L52.024 199.212L53.6551 198.268Z",
    fill: "#59595B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8356 191.228L57.0026 189.597C55.3715 188.653 55.3715 187.108 57.0026 186.078C58.6337 185.133 61.3808 185.133 63.0119 186.078L65.8449 187.709C67.476 188.653 67.476 190.198 65.8449 191.228C64.1279 192.173 61.4667 192.173 59.8356 191.228ZM58.5479 188.653L61.3808 190.284C62.1535 190.713 63.4412 190.713 64.2138 190.284C64.9864 189.855 64.9864 189.082 64.2138 188.653L61.3808 187.022C60.6082 186.593 59.3205 186.593 58.5479 187.022C57.7752 187.537 57.7752 188.224 58.5479 188.653Z",
    fill: "#C0162E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0955 182.987L73.1419 179.038L71.5966 178.094L69.9655 179.038L68.7637 179.725L70.3948 180.583L71.5966 179.982L78.4644 183.931L80.0955 182.987Z",
    fill: "#59595B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3162 175.347L86.4484 171.398L84.8173 170.453L83.1862 171.398L81.9844 172.084L83.6155 172.943L84.8173 172.342L91.6851 176.291L93.3162 175.347Z",
    fill: "#59595B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4977 168.307L96.6647 166.676C95.0336 165.732 95.0336 164.187 96.6647 163.156C98.2958 162.212 101.043 162.212 102.674 163.156L105.507 164.787C107.138 165.732 107.138 167.277 105.507 168.307C103.876 169.252 101.129 169.252 99.4977 168.307ZM98.2958 165.732L101.129 167.363C101.901 167.792 103.189 167.792 103.962 167.363C104.734 166.934 104.734 166.161 103.962 165.732L101.129 164.101C100.356 163.671 99.0685 163.671 98.2958 164.101C97.5232 164.616 97.5232 165.303 98.2958 165.732Z",
    fill: "#C0162E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6385 196.809L17.7707 192.86L16.1396 191.915L14.5085 192.86L13.3066 193.546L14.9377 194.491L16.1396 193.804L23.0074 197.753L24.6385 196.809Z",
    fill: "#59595B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.819 189.769L27.986 188.138C26.3549 187.194 26.3549 185.648 27.986 184.618C29.6171 183.674 32.3642 183.674 33.9953 184.618L36.8283 186.249C38.4594 187.194 38.4594 188.739 36.8283 189.769C35.1972 190.799 32.4501 190.799 30.819 189.769ZM29.6171 187.194L32.4501 188.825C33.2227 189.254 34.5104 189.254 35.283 188.825C36.0557 188.395 36.0557 187.623 35.283 187.194L32.4501 185.562C31.6775 185.133 30.3897 185.133 29.6171 185.562C28.8445 186.078 28.8445 186.764 29.6171 187.194Z",
    fill: "#C0162E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0407 182.129L41.2077 180.498C39.5766 179.553 39.5766 178.008 41.2077 176.978C42.8388 176.034 45.5859 176.034 47.217 176.978L50.05 178.609C51.6811 179.553 51.6811 181.099 50.05 182.129C48.4189 183.159 45.7576 183.159 44.0407 182.129ZM42.8388 179.553L45.6718 181.184C46.4444 181.614 47.7321 181.614 48.5047 181.184C49.2774 180.755 49.2774 179.983 48.5047 179.553L45.6718 177.922C44.8991 177.493 43.6114 177.493 42.8388 177.922C42.0662 178.437 42.0662 179.124 42.8388 179.553Z",
    fill: "#C0162E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2604 174.488L54.4274 172.857C52.7963 171.913 52.7963 170.368 54.4274 169.337C56.0585 168.393 58.8056 168.393 60.4367 169.337L63.2697 170.968C64.9008 171.913 64.9008 173.458 63.2697 174.488C61.6386 175.518 58.9773 175.518 57.2604 174.488ZM56.0585 171.913L58.8915 173.544C59.6641 173.973 60.9518 173.973 61.7245 173.544C62.4971 173.115 62.4971 172.342 61.7245 171.913L58.8915 170.282C58.1189 169.852 56.8311 169.852 56.0585 170.282C55.2859 170.797 55.2859 171.484 56.0585 171.913Z",
    fill: "#C0162E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6063 166.247L70.6526 162.298L69.0215 161.354L67.3904 162.298L66.2744 162.985L67.9055 163.929L69.0215 163.242L75.9752 167.191L77.6063 166.247Z",
    fill: "#59595B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7877 159.207L80.9548 157.576C79.3237 156.632 79.3237 155.087 80.9548 154.057C82.5859 153.112 85.333 153.112 86.9641 154.057L89.7971 155.688C91.4282 156.632 91.4282 158.177 89.7971 159.207C88.166 160.238 85.4188 160.238 83.7877 159.207ZM82.5 156.632L85.333 158.263C86.1056 158.692 87.3933 158.692 88.166 158.263C88.9386 157.834 88.9386 157.061 88.166 156.632L85.333 155.001C84.5604 154.572 83.2727 154.572 82.5 155.001C81.7274 155.516 81.7274 156.203 82.5 156.632Z",
    fill: "#C0162E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.048 150.966L97.1799 147.017L95.5488 146.073L93.9177 147.017L92.7158 147.704L94.3469 148.648L95.5488 147.961L102.417 151.91L104.048 150.966Z",
    fill: "#59595B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M252.478 14.2972C257.628 17.6453 268.531 25.0282 272.995 34.8148C275.914 41.2533 277.03 51.6409 282.267 54.5597C292.826 60.3114 298.835 34.9865 312.313 42.0259C326.306 49.2371 321.671 74.7338 331.886 80.0563C339.098 83.8336 340.814 65.8915 361.246 77.3951V124.182L252.735 61.4274L252.478 14.2972Z",
    fill: "url(#paint0_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M254.108 3.05122C254.108 2.02105 253.421 0.733343 252.477 0.218258C251.618 -0.296826 250.846 0.132411 250.846 1.16258C250.846 2.1069 251.447 3.13707 252.133 3.738V53.2719L252.734 53.6153V4.16724C253.507 4.42478 254.108 3.99554 254.108 3.05122Z",
    fill: "#292929"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M362.791 65.8056C362.791 64.7754 362.104 63.4877 361.159 62.9727C360.301 62.4576 359.528 62.8868 359.528 63.917C359.528 64.8613 360.129 65.8915 360.816 66.4924V115.94L361.417 116.284V66.8358C362.19 67.1792 362.791 66.7499 362.791 65.8056Z",
    fill: "#292929"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M277.202 364.211C276.172 363.61 274.712 363.524 273.51 363.953L254.796 353.137L253.68 353.738L272.394 364.554C271.708 365.241 271.879 366.1 272.909 366.701C274.111 367.387 276 367.387 277.202 366.701C278.404 366.014 278.404 364.898 277.202 364.211Z",
    fill: "url(#paint1_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M296.002 353.308C294.972 352.707 293.512 352.622 292.31 353.051L273.596 342.234L272.479 342.835L291.194 353.652C290.507 354.338 290.679 355.197 291.709 355.798C292.911 356.485 294.8 356.485 296.002 355.798C297.204 355.111 297.204 353.995 296.002 353.308Z",
    fill: "url(#paint2_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M314.802 342.492C313.772 341.891 312.313 341.805 311.111 342.234L292.396 331.417L291.28 332.018L309.995 342.835C309.308 343.522 309.48 344.38 310.51 344.981C311.712 345.668 313.601 345.668 314.802 344.981C316.004 344.294 316.004 343.178 314.802 342.492Z",
    fill: "url(#paint3_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M333.689 331.589C332.659 330.988 331.2 330.902 329.998 331.331L311.283 320.515L310.167 321.116L328.882 331.932C328.195 332.619 328.367 333.478 329.397 334.079C330.599 334.765 332.487 334.765 333.689 334.079C334.891 333.392 334.891 332.276 333.689 331.589Z",
    fill: "url(#paint4_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M352.49 320.772C351.46 320.171 350 320.085 348.799 320.515L330.084 309.698L328.968 310.299L347.682 321.116C346.996 321.802 347.167 322.661 348.198 323.262C349.399 323.949 351.288 323.949 352.49 323.262C353.692 322.575 353.692 321.459 352.49 320.772Z",
    fill: "url(#paint5_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M371.29 309.87C370.26 309.269 368.8 309.183 367.598 309.612L348.884 298.795L347.768 299.396L366.482 310.213C365.796 310.9 365.967 311.758 366.997 312.359C368.199 313.046 370.088 313.046 371.29 312.359C372.492 311.672 372.492 310.556 371.29 309.87Z",
    fill: "url(#paint6_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M195.474 364.211C196.504 363.61 197.963 363.524 199.165 363.953L217.88 353.137L218.996 353.738L200.281 364.554C200.968 365.241 200.796 366.1 199.766 366.701C198.564 367.387 196.676 367.387 195.474 366.701C194.272 366.014 194.272 364.898 195.474 364.211Z",
    fill: "url(#paint7_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.674 353.308C177.704 352.707 179.163 352.622 180.365 353.051L199.08 342.234L200.196 342.835L181.481 353.652C182.168 354.338 181.996 355.197 180.966 355.798C179.764 356.485 177.876 356.485 176.674 355.798C175.472 355.111 175.472 353.995 176.674 353.308Z",
    fill: "url(#paint8_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M157.788 342.492C158.818 341.891 160.278 341.805 161.48 342.234L180.194 331.417L181.31 332.018L162.596 342.835C163.282 343.522 163.111 344.38 162.08 344.981C160.879 345.668 158.99 345.668 157.788 344.981C156.586 344.294 156.586 343.178 157.788 342.492Z",
    fill: "url(#paint9_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M138.986 331.589C140.017 330.988 141.476 330.902 142.678 331.331L161.393 320.515L162.509 321.116L143.794 331.932C144.481 332.619 144.309 333.478 143.279 334.079C142.077 334.765 140.188 334.765 138.986 334.079C137.784 333.392 137.784 332.276 138.986 331.589Z",
    fill: "url(#paint10_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.187 320.772C121.217 320.171 122.676 320.085 123.878 320.515L142.593 309.698L143.709 310.299L124.994 321.116C125.681 321.802 125.509 322.661 124.479 323.262C123.277 323.949 121.388 323.949 120.187 323.262C118.985 322.575 118.985 321.459 120.187 320.772Z",
    fill: "url(#paint11_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.386 309.87C102.416 309.269 103.875 309.183 105.077 309.612L123.792 298.795L124.908 299.396L106.193 310.213C106.88 310.9 106.708 311.758 105.678 312.359C104.476 313.046 102.588 313.046 101.386 312.359C100.184 311.672 100.184 310.556 101.386 309.87Z",
    fill: "url(#paint12_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M357.125 213.721H236.338L366.397 288.751L236.338 363.868H357.125L487.184 288.751L357.125 213.721Z",
    fill: "url(#paint13_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M236.338 143.927L366.397 219.043L236.338 294.074L106.279 219.043L236.338 143.927Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M106.278 219.043L236.337 294.074V363.868L106.278 288.751V219.043Z",
    fill: "#292929"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M236.337 294.074L366.396 219.043V288.751L236.337 363.868V294.074Z",
    fill: "#292929"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M248.956 190.198L152.636 245.827L189.894 267.289L234.448 267.461L308.964 224.451L248.956 190.198Z",
    fill: "url(#paint14_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M236.338 143.927L106.279 219.043L143.537 240.505L188.092 240.677L296.002 178.351L236.338 143.927Z",
    fill: "url(#paint15_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M282.609 170.625L222.43 205.393L278.145 237.586H259.687L222.43 259.134L259.687 280.596L296.945 259.134L306.131 253.811L343.389 232.264L366.396 219.043L282.609 170.625Z",
    fill: "url(#paint16_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.719 268.92L172.895 270.723V274.415L169.719 272.526V268.92Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M160.362 263.512L163.453 265.315V268.92L160.362 267.118V263.512Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M150.919 258.104L154.009 259.906V263.512L150.919 261.709V258.104Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M141.476 252.609L144.652 254.498V258.104L141.476 256.301V252.609Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M132.118 247.201L135.209 249.004V252.609L132.118 250.807V247.201Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M122.675 241.793L125.851 243.595V247.201L122.675 245.398V241.793Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M216.764 296.134L219.94 297.937V301.542L216.764 299.74V296.134Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M207.32 290.64L210.497 292.443V296.134L207.32 294.331V290.64Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M197.963 285.231L201.053 287.034V290.64L197.963 288.837V285.231Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M188.52 279.823L191.696 281.626V285.231L188.52 283.429V279.823Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M179.162 274.415L182.253 276.217V279.823L179.162 278.02V274.415Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M169.719 308.496L172.895 310.299V313.904L169.719 312.102V308.496Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M160.362 303.088L163.453 304.89V308.496L160.362 306.693V303.088Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M150.919 297.679L154.009 299.482V303.088L150.919 301.285V297.679Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M141.476 292.185L144.652 293.988V297.679L141.476 295.791V292.185Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M132.118 286.777L135.209 288.579V292.185L132.118 290.382V286.777Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M122.675 281.368L125.851 283.171V286.777L122.675 284.974V281.368Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M216.764 335.624L219.94 337.512V341.118L216.764 339.315V335.624Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M207.32 330.215L210.497 332.018V335.624L207.32 333.821V330.215Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M197.963 324.807L201.053 326.61V330.215L197.963 328.413V324.807Z",
    fill: "#C0162E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M188.52 319.399L191.696 321.201V324.807L188.52 323.004V319.399Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M179.162 313.904L182.253 315.707V319.399L179.162 317.596V313.904Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M169.719 288.751L172.895 290.554V294.159L169.719 292.357V288.751Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M160.362 283.257L163.453 285.145V288.751L160.362 286.948V283.257Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M150.919 277.849L154.009 279.651V283.257L150.919 281.454V277.849Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M141.476 272.44L144.652 274.243V277.849L141.476 276.046V272.44Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M132.118 267.032L135.209 268.835V272.44L132.118 270.637V267.032Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M122.675 261.538L125.851 263.34V267.032L122.675 265.229V261.538Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M216.764 315.879L219.94 317.682V321.287L216.764 319.485V315.879Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M207.32 310.47L210.497 312.273V315.879L207.32 314.076V310.47Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M197.963 304.976L201.053 306.865V310.471L197.963 308.668V304.976Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M188.52 299.568L191.696 301.371V304.976L188.52 303.173V299.568Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M179.162 294.16L182.253 295.962V299.568L179.162 297.765V294.16Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M302.954 268.92L299.777 270.723V274.415L302.954 272.526V268.92Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M312.311 263.512L309.221 265.315V268.92L312.311 267.118V263.512Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M321.754 258.104L318.578 259.907V263.512L321.754 261.709V258.104Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M331.112 252.609L328.021 254.498V258.104L331.112 256.301V252.609Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M340.555 247.201L337.465 249.004V252.609L340.555 250.807V247.201Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M349.999 241.793L346.822 243.596V247.201L349.999 245.398V241.793Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M255.91 296.134L252.733 297.937V301.542L255.91 299.74V296.134Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M265.267 290.64L262.177 292.443V296.134L265.267 294.331V290.64Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M274.711 285.231L271.534 287.034V290.64L274.711 288.837V285.231Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M284.154 279.823L280.978 281.626V285.231L284.154 283.429V279.823Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M293.511 274.415L290.421 276.218V279.823L293.511 278.02V274.415Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M302.954 308.496L299.777 310.299V313.904L302.954 312.102V308.496Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M312.311 303.088L309.221 304.891V308.496L312.311 306.693V303.088Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M321.754 297.679L318.578 299.482V303.088L321.754 301.285V297.679Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M331.112 292.185L328.021 293.988V297.679L331.112 295.791V292.185Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M340.555 286.777L337.465 288.58V292.185L340.555 290.382V286.777Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M349.999 281.368L346.822 283.171V286.777L349.999 284.974V281.368Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M255.91 335.624L252.733 337.513V341.118L255.91 339.315V335.624Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M265.267 330.216L262.177 332.018V335.624L265.267 333.821V330.216Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M274.711 324.807L271.534 326.61V330.216L274.711 328.413V324.807Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M284.154 319.399L280.978 321.202V324.807L284.154 323.004V319.399Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M293.511 313.905L290.421 315.707V319.399L293.511 317.596V313.905Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M302.954 288.751L299.777 290.554V294.16L302.954 292.357V288.751Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M312.311 283.257L309.221 285.146V288.751L312.311 286.948V283.257Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M321.754 277.849L318.578 279.651V283.257L321.754 281.454V277.849Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M331.112 272.44L328.021 274.243V277.849L331.112 276.046V272.44Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M340.555 267.032L337.465 268.835V272.44L340.555 270.637V267.032Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M349.999 261.538L346.822 263.34V267.032L349.999 265.229V261.538Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M255.91 315.879L252.733 317.682V321.287L255.91 319.485V315.879Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M265.267 310.471L262.177 312.273V315.879L265.267 314.076V310.471Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M274.711 304.976L271.534 306.865V310.471L274.711 308.668V304.976Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M284.154 299.568L280.978 301.371V304.976L284.154 303.174V299.568Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M293.511 294.16L290.421 295.962V299.568L293.511 297.765V294.16Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M236.338 63.4877L273.596 85.0354L143.537 160.066L106.279 138.604L236.338 63.4877Z",
    fill: "#C0162E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M106.278 138.604L143.536 160.066V229.86L106.278 208.312V138.604Z",
    fill: "url(#paint17_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M143.536 160.066L273.595 85.0354V154.743L143.536 229.86V160.066Z",
    fill: "url(#paint18_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M123.361 181.528L126.452 183.331V186.936L123.361 185.133V181.528Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M123.361 168.136L126.452 169.938V173.544L123.361 171.741V168.136Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M123.361 194.834L126.452 196.637V200.328L123.361 198.44V194.834Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M189.893 113.623L186.803 111.82L189.893 110.017L193.07 111.82L189.893 113.623Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M177.359 120.834L174.269 119.031L177.359 117.228L180.535 119.031L177.359 120.834Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M164.826 128.131L161.735 126.242L164.826 124.439L168.002 126.242L164.826 128.131Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M152.292 135.342L149.115 133.539L152.292 131.736L155.382 133.539L152.292 135.342Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M139.758 142.553L136.582 140.75L139.758 138.948L142.849 140.75L139.758 142.553Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M240.114 84.6061L236.938 82.8033L240.114 81.0005L243.204 82.8033L240.114 84.6061Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M227.581 91.9031L224.404 90.1003L227.581 88.2975L230.671 90.1003L227.581 91.9031Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M215.045 99.1144L211.869 97.3116L215.045 95.5088L218.136 97.3116L215.045 99.1144Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M202.426 106.326L199.336 104.523L202.426 102.72L205.603 104.523L202.426 106.326Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M282.781 90.3579L366.568 138.69L306.132 173.544L222.431 125.212L282.781 90.3579Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M222.43 125.212L306.131 173.544V243.338L222.43 195.006V125.212Z",
    fill: "#292929"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M306.131 173.544L366.567 138.69V208.484L306.131 243.338V173.544Z",
    fill: "#292929"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M213.158 130.534L250.416 152.082L189.979 186.936L152.722 165.388L213.158 130.534Z",
    fill: "url(#paint19_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M152.722 165.388L189.979 186.936V256.644L152.722 235.182V165.388Z",
    fill: "#59595B"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M189.979 186.936L250.416 152.082V221.79L189.979 256.644V186.936Z",
    fill: "#59595B"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M198.392 182.043L195.302 183.846V253.639L198.392 251.837V182.043Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M207.836 176.635L204.659 178.437V248.231L207.836 246.428V176.635Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M217.279 171.226L214.103 173.029V242.737L217.279 240.934V171.226Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M226.636 165.818L223.546 167.621V237.329L226.636 235.526V165.818Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M236.079 160.323L232.902 162.126V231.92L236.079 230.117V160.323Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M245.436 154.915L242.346 156.718V226.512L245.436 224.623V154.915Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M161.22 160.581L158.044 162.384L195.302 183.846L198.392 182.043L161.22 160.581Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M170.578 155.173L167.487 156.976L204.659 178.437L207.836 176.635L170.578 155.173Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M180.021 149.678L176.845 151.481L214.102 173.029L217.279 171.226L180.021 149.678Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M189.379 144.27L186.288 146.073L223.546 167.621L226.636 165.818L189.379 144.27Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M198.821 138.862L195.645 140.665L232.902 162.126L236.079 160.324L198.821 138.862Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M208.178 133.453L205.088 135.256L242.346 156.718L245.436 154.915L208.178 133.453Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M169.805 195.006L172.981 196.809V200.414L169.805 198.611V195.006Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M158.989 188.739L162.08 190.542V194.147L158.989 192.345V188.739Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M180.622 201.273L183.798 203.076V206.681L180.622 204.878V201.273Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M169.805 221.704L172.981 223.507V227.113L169.805 225.31V221.704Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M158.988 215.438L162.079 217.24V220.846L158.988 219.043V215.438Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M180.622 227.971L183.798 229.774V233.38L180.622 231.577V227.971Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M259.688 157.405L296.946 178.952L259.688 200.414L222.431 178.867L259.688 157.405Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M222.43 178.867L259.687 200.414V270.122L222.43 248.66V178.867Z",
    fill: "#292929"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M259.688 200.414L296.945 178.952V248.66L259.688 270.122V200.414Z",
    fill: "#292929"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M239.514 221.79L242.604 223.593V227.285L239.514 225.482V221.79Z",
    fill: "#59595B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M239.514 208.484L242.604 210.287V213.892L239.514 212.089V208.484Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M239.514 235.182L242.604 236.985V240.591L239.514 238.788V235.182Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M279.862 221.79L276.686 223.593V227.285L279.862 225.482V221.79Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M279.862 208.484L276.686 210.287V213.892L279.862 212.089V208.484Z",
    fill: "#C0162E"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M279.862 235.182L276.686 236.985V240.591L279.862 238.788V235.182Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M116.495 357.772H65.7588L69.7078 366.357H116.495V357.772Z",
    fill: "url(#paint20_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M104.991 346.441H57.7754L58.2046 351.849H104.991V346.441Z",
    fill: "url(#paint21_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6845 338.457C53.1392 337.341 50.6497 339.229 49.9629 341.204C49.9629 342.062 50.5638 343.522 50.5638 343.522C50.5638 343.522 53.2251 349.359 54.0836 350.39C54.942 351.42 58.6335 352.793 60.3504 351.334C61.6381 349.703 59.1486 348.758 58.6335 347.127C58.0325 345.067 58.2901 343.35 57.6892 341.805C57.2599 340.431 54.6845 338.457 54.6845 338.457Z",
    fill: "#C0162E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1342 340.775C50.1342 340.775 50.1342 340.861 50.1342 340.775C50.1342 341.633 50.7351 343.178 50.7351 343.178C50.7351 343.178 53.3964 349.016 54.2549 350.046C55.1133 351.076 58.8048 352.45 60.5217 350.99C60.6076 350.905 60.6076 350.819 60.6934 350.733C60.6076 350.905 60.5217 351.162 60.35 351.42C58.6331 352.879 54.9417 351.506 54.0832 350.475C53.2247 349.445 50.5634 343.608 50.5634 343.608C50.5634 343.608 49.8767 342.148 49.9625 341.29C49.9625 341.032 50.0484 340.946 50.1342 340.775Z",
    fill: "#131147"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9761 339.745C58.2035 339.229 55.0271 338.028 55.0271 338.028C55.0271 338.028 54.7696 338.371 54.3404 338.543C54.2545 338.543 54.2545 338.543 54.1687 338.629C53.396 338.629 51.9366 339.401 52.881 340.946C54.5979 344.037 58.5469 343.951 58.1176 342.492C57.7743 341.461 58.5469 340.345 58.9761 339.745Z",
    fill: "#59595B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M58.118 343.264C58.2038 342.749 58.3755 341.719 57.1737 341.547C55.886 341.376 54.4266 341.977 54.5124 342.749C54.7699 344.38 58.0321 343.779 58.118 343.264Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3109 338.113C54.7703 336.139 65.7588 322.918 70.9096 320.343C69.1927 313.046 64.6428 303.603 66.1022 295.876H77.0906C77.0906 295.876 83.615 318.969 79.4085 324.378C76.2321 328.584 62.3249 339.144 57.0882 342.492C55.2854 342.577 52.6241 339.659 53.3109 338.113Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5827 357.257C60.6941 357.601 60.179 360.605 61.1233 362.494C61.7243 363.181 63.1837 363.782 63.1837 363.782C63.1837 363.782 69.1071 366.185 70.4807 366.357C71.8543 366.443 74.7731 365.928 75.0306 363.696C74.7731 362.322 73.657 361.893 72.1976 361.035C70.309 359.919 68.6779 358.288 67.2185 357.601C65.9308 356.914 62.5827 357.257 62.5827 357.257Z",
    fill: "#C0162E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3953 365.756C69.0217 365.671 62.9265 363.095 62.9265 363.095C62.9265 363.095 61.4671 362.494 60.8662 361.807C60.9521 362.065 61.0379 362.237 61.1237 362.494C61.7247 363.181 63.1841 363.782 63.1841 363.782C63.1841 363.782 69.1076 366.186 70.4811 366.357C71.8547 366.443 74.7735 365.928 75.031 363.696C75.031 363.61 75.031 363.61 75.031 363.524C74.3442 365.413 71.683 365.842 70.3953 365.756Z",
    fill: "#292929"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6179 355.283C65.6736 355.455 62.5831 356.742 62.5831 356.742C62.5831 356.742 62.6689 357.172 62.4114 357.601L62.3255 357.687C61.7246 358.202 61.1237 359.232 62.9265 359.747C66.2745 360.777 69.1075 358.545 67.8198 357.773C66.9613 357.343 66.7896 355.97 66.6179 355.283Z",
    fill: "#292929"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4213 358.288C68.1637 357.944 67.5628 357.086 66.5326 357.772C65.5025 358.545 65.2449 359.489 65.3308 360.176C65.4166 360.949 67.6487 360.348 67.7345 360.262C67.9062 360.262 68.4213 358.288 68.4213 358.288Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3906 298.967C67.3906 309.269 67.4765 317.338 67.4765 326.266C67.4765 336.568 68.2491 349.359 68.1632 357.944C66.5321 360.004 62.3256 359.489 61.3813 357.858C60.2653 350.046 57.8616 338.113 58.4625 329.529C55.8871 318.283 53.3117 304.976 54.4277 296.22C56.9172 297.078 64.901 298.194 67.3906 298.967Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9235 270.122C83.6149 272.183 87.1347 283.6 88.7658 285.661C90.3969 287.721 93.3157 290.382 93.3157 290.382C91.5987 291.842 87.8215 293.902 87.8215 293.902C86.0187 292.357 83.014 292.7 79.3226 283.6C75.717 274.586 79.9235 270.122 79.9235 270.122Z",
    fill: "url(#paint22_linear)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6937 273.899C62.8399 271.152 68.2483 267.375 71.768 267.118C77.6915 266.688 82.2414 271.238 83.0999 275.702C83.8725 279.651 76.4896 299.74 77.7773 304.976C77.1764 307.723 72.5406 309.269 70.5661 309.698C62.1531 311.586 53.6542 310.385 53.5684 304.976C53.1391 287.206 57.5173 277.076 60.6937 273.899Z",
    fill: "url(#paint23_linear)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M126.108 332.791L105.076 344.895C103.96 345.582 102.844 345.582 102.157 345.153C101.384 344.724 100.955 343.779 100.955 342.406V318.197C100.955 316.823 101.384 315.364 102.157 314.076C102.93 312.788 103.96 311.587 105.076 310.986L126.108 298.881C127.224 298.194 128.34 298.194 129.027 298.624C129.8 299.053 130.229 299.997 130.229 301.371V325.58C130.229 326.953 129.8 328.413 129.027 329.7C128.34 330.902 127.31 332.104 126.108 332.791Z",
    fill: "#313131"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M100.956 342.492V318.283C100.956 316.909 101.385 315.45 102.157 314.162C102.93 312.874 103.96 311.672 105.076 311.071L126.109 298.967C127.225 298.28 128.341 298.28 129.028 298.709L101.556 282.828C100.784 282.398 99.7537 282.484 98.6377 283.085L77.6051 295.19C76.489 295.877 75.373 296.993 74.6862 298.28C73.9136 299.568 73.4844 301.027 73.4844 302.401V326.696C73.4844 328.069 73.9136 328.928 74.6862 329.443L102.157 345.325C101.471 344.724 100.956 343.779 100.956 342.492Z",
    fill: "#292929"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8645 311.587C98.6371 310.299 99.6673 309.097 100.783 308.496L121.816 296.392C122.932 295.705 124.048 295.705 124.735 296.134L126.022 296.907C125.25 296.477 124.22 296.563 123.104 297.164L102.071 309.269C100.955 309.955 99.839 311.071 99.1522 312.359C98.3796 313.647 97.9504 315.106 97.9504 316.48V340.689C97.9504 342.062 98.3796 342.921 99.1522 343.436L97.8645 342.663C97.0919 342.234 96.6626 341.29 96.6626 339.916V315.707C96.5768 314.334 97.0919 312.874 97.8645 311.587Z",
    fill: "url(#paint24_linear)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M94.345 309.526C95.1176 308.238 96.1478 307.037 97.2638 306.436L118.296 294.331C119.412 293.644 120.528 293.644 121.215 294.074L122.503 294.846C121.73 294.417 120.7 294.503 119.584 295.104L98.5515 307.208C97.4355 307.895 96.3195 309.011 95.6327 310.299C94.8601 311.587 94.4308 313.046 94.4308 314.42V338.628C94.4308 340.002 94.8601 340.861 95.6327 341.376L94.345 340.603C93.5724 340.174 93.1431 339.229 93.1431 337.856V313.561C93.0573 312.359 93.5724 310.814 94.345 309.526Z",
    fill: "url(#paint25_linear)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M90.74 307.466C91.5126 306.178 92.5427 304.976 93.6588 304.375L114.691 292.271C115.807 291.584 116.923 291.584 117.61 292.013L118.898 292.786C118.125 292.357 117.095 292.443 115.979 293.044L94.9465 305.148C93.8305 305.835 92.7144 306.951 92.0277 308.239C91.255 309.526 90.8258 310.986 90.8258 312.359V336.654C90.8258 338.028 91.255 338.886 92.0277 339.401L90.74 338.628C89.9673 338.199 89.5381 337.255 89.5381 335.881V311.587C89.5381 310.299 90.0532 308.839 90.74 307.466Z",
    fill: "url(#paint26_linear)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2191 305.491C87.9918 304.204 89.0219 303.002 90.1379 302.401L111.171 290.296C112.287 289.61 113.403 289.524 114.089 290.039L115.377 290.812C114.604 290.382 113.574 290.468 112.458 291.069L91.5115 303.088C90.3955 303.774 89.2795 304.89 88.5927 306.178C87.8201 307.466 87.3908 308.925 87.3908 310.299V334.594C87.3908 335.967 87.8201 336.826 88.5927 337.341L87.305 336.568C86.5324 336.139 86.1031 335.195 86.1031 333.821V309.526C86.0173 308.239 86.5324 306.779 87.2191 305.491Z",
    fill: "url(#paint27_linear)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6999 303.431C84.4725 302.143 85.5027 300.941 86.6187 300.34L107.651 288.236C108.767 287.549 109.883 287.549 110.57 287.978L111.858 288.751C111.085 288.322 110.055 288.408 108.939 289.009L87.9064 301.113C86.7904 301.8 85.6744 302.916 84.9876 304.204C84.215 305.491 83.7858 306.951 83.7858 308.324V332.619C83.7858 333.993 84.215 334.851 84.9876 335.366L83.6999 334.594C82.9273 334.164 82.498 333.22 82.498 331.846V307.552C82.498 306.178 82.9273 304.719 83.6999 303.431Z",
    fill: "url(#paint28_linear)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1794 301.371C80.952 300.083 81.9822 298.881 83.0982 298.28L104.131 286.176C105.247 285.489 106.363 285.489 107.05 285.918L108.337 286.691C107.565 286.262 106.535 286.348 105.419 286.948L84.3859 299.053C83.2699 299.74 82.1539 300.856 81.4671 302.143C80.6945 303.431 80.2652 304.891 80.2652 306.264V330.559C80.2652 331.932 80.6945 332.791 81.4671 333.306L80.1794 332.533C79.4068 332.104 78.9775 331.16 78.9775 329.786V305.577C78.9775 304.204 79.4068 302.659 80.1794 301.371Z",
    fill: "url(#paint29_linear)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6599 299.31C77.4325 298.023 78.4627 296.821 79.5787 296.22L100.611 284.115C101.727 283.429 102.843 283.429 103.53 283.858L104.818 284.63C104.045 284.201 103.015 284.287 101.899 284.888L80.8664 296.992C79.7504 297.679 78.6344 298.795 77.9476 300.083C77.175 301.371 76.7457 302.83 76.7457 304.204V328.498C76.7457 329.872 77.175 330.731 77.9476 331.246L76.6599 330.473C75.8872 330.044 75.458 329.099 75.458 327.726V303.517C75.458 302.143 75.8872 300.684 76.6599 299.31Z",
    fill: "url(#paint30_linear)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6271 312.874C72.8846 313.218 73.4855 316.995 70.6526 317.596C69.3649 316.652 69.5366 312.96 72.6271 312.874Z",
    fill: "#C17200"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9963 312.617L72.6274 313.561C73.5718 313.99 76.0613 313.99 77.6924 312.96C79.3235 311.844 79.066 314.591 77.349 315.106C75.6321 315.535 75.4604 316.222 77.95 317.166C79.066 317.596 80.182 318.54 80.5254 319.055C81.298 320.171 81.8989 322.403 80.2678 323.09C78.8943 323.691 75.7179 321.373 74.7736 320.772C72.1124 319.055 72.7991 318.54 71.2539 317.424C69.7945 316.308 69.3652 316.308 69.3652 316.308L70.9963 312.617Z",
    fill: "#FCD1A9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5576 274.071C62.7548 273.299 59.5784 272.869 57.6898 278.364C56.5738 281.454 55.7153 292.357 57.0889 297.937C58.9775 305.491 63.6991 313.303 70.6527 317.682C69.7943 316.136 70.9961 313.389 72.6272 312.96C67.9056 307.552 64.5576 300.512 64.5576 297.078C64.5576 291.326 65.5877 282.656 66.017 280.853C66.8755 277.076 66.2745 274.758 64.5576 274.071Z",
    fill: "url(#paint31_linear)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9949 259.134C70.7373 257.159 77.4334 261.108 77.1759 263.684C76.9183 265.744 76.3174 267.547 78.4636 268.92C79.1504 269.521 81.64 273.556 77.8627 273.556C72.4543 273.642 70.9949 272.097 67.0459 268.749C69.3638 267.461 71.6817 265.401 70.9949 259.134Z",
    fill: "#FCD1A9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3643 258.018L72.1114 254.24H83.9583V261.366C83.9583 265.315 81.297 268.491 78.0348 268.491C74.8585 268.491 71.9397 265.83 71.768 262.138L70.3086 261.623L69.3643 258.018Z",
    fill: "#FCD1A9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7768 270.294C74.9438 270.294 71.4241 265.744 71.7674 261.967C71.9391 265.487 74.858 268.062 77.7768 268.319C78.0343 268.491 78.206 268.663 78.4635 268.835C78.5494 268.92 78.5494 268.92 78.6352 269.006C78.6352 269.693 78.2918 270.294 77.7768 270.294Z",
    fill: "#F2C39D"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2698 250.987C84.3858 250.816 84.4717 249.871 80.0935 248.412C77.518 247.124 73.9124 246.781 71.5946 248.24C68.4182 250.215 67.4739 253.048 68.0748 256.653C68.6758 260.259 70.9936 263.693 70.9936 263.693C71.337 264.036 71.4229 262.405 71.0795 261.117C70.9078 261.031 70.8219 260.688 70.6502 260.087C69.7918 256.396 72.0238 256.997 72.3672 257.254C73.054 257.512 71.6804 260.602 73.7408 260.259C74.6851 260.087 74.5992 257.34 74.5992 256.396C74.7709 256.396 74.8568 256.482 75.0285 256.482C76.7454 257.426 82.4113 258.113 79.235 256.138C81.467 256.138 84.4717 257.168 85.416 255.795C86.6178 254.164 84.6434 252.361 83.2698 250.987Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M187.662 389.793H152.293V397.176H187.662V389.793Z",
    fill: "url(#paint32_linear)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M171.78 400.439H133.75V407.821H171.78V400.439Z",
    fill: "url(#paint33_linear)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M156.584 394.858C156.584 389.021 152.893 388.849 152.893 388.849C152.893 388.849 150.832 389.021 147.57 387.819C143.449 386.274 139.93 386.703 142.505 391.339C142.505 391.425 142.591 391.425 142.591 391.51C142.763 391.768 143.02 392.025 143.364 392.197L151.433 396.919C152.635 397.691 156.584 396.06 156.584 394.858Z",
    fill: "#C0162E"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M156.584 394.343C156.498 395.545 152.635 397.09 151.433 396.404L143.363 391.682C143.106 391.51 142.676 391.253 142.247 390.823C142.333 390.995 142.419 391.167 142.505 391.339C142.505 391.424 142.59 391.424 142.59 391.51C142.762 391.768 143.02 392.025 143.363 392.197L151.433 396.919C152.549 397.605 156.068 396.232 156.498 395.03C156.498 394.944 156.498 394.858 156.498 394.772C156.584 394.687 156.584 394.515 156.584 394.343Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M155.125 388.162C154.609 388.162 153.579 388.334 152.635 388.591C151.862 388.42 149.201 388.334 147.484 387.819C146.969 387.647 146.454 387.39 145.939 387.733C145.252 388.591 147.055 390.566 150.66 392.197C151.948 392.97 152.978 392.455 153.493 392.025C153.665 391.682 154.009 391.253 154.438 390.995C154.867 390.738 155.125 390.652 155.296 390.652V390.566C155.296 390.566 155.468 388.162 155.125 388.162Z",
    fill: "#FCD1A9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M153.237 349.874C154.868 344.895 154.095 339.143 152.893 333.392C149.288 333.478 142.334 331.417 138.729 331.503C140.102 342.492 143.107 352.106 144.995 362.666C146.97 372.967 149.288 380.522 151.176 389.107C151.863 390.738 155.297 389.965 155.297 389.021C155.812 381.123 155.469 371.937 153.151 362.837C153.323 358.803 152.636 353.995 153.237 349.874Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M138.214 405.59C138.214 399.752 134.523 399.58 134.523 399.58C134.523 399.58 132.376 399.666 129.114 398.464C124.994 396.919 121.646 397.434 124.135 402.07C124.135 402.156 124.221 402.156 124.221 402.241C124.393 402.499 124.65 402.757 125.079 402.928L133.149 407.65C134.265 408.422 138.214 406.791 138.214 405.59Z",
    fill: "#C0162E"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M138.213 405.074C138.128 406.276 134.264 407.822 133.063 407.135L124.993 402.413C124.735 402.241 124.306 401.984 123.877 401.555C123.963 401.726 124.049 401.898 124.134 402.07C124.134 402.156 124.22 402.156 124.22 402.241C124.392 402.499 124.65 402.757 125.079 402.928L133.148 407.65C134.264 408.337 137.784 406.963 138.213 405.761C138.213 405.675 138.213 405.589 138.213 405.504C138.213 405.418 138.213 405.246 138.213 405.074Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M136.754 398.807C136.239 398.807 135.209 398.979 134.265 399.237C133.492 399.065 130.831 398.979 129.114 398.464C128.599 398.292 128.084 398.035 127.569 398.378C126.882 399.237 128.685 401.211 132.29 402.842C133.578 403.615 134.608 403.1 135.123 402.671C135.295 402.327 135.638 401.898 136.068 401.64C136.497 401.383 136.754 401.297 136.926 401.297V401.211C136.926 401.211 137.098 398.807 136.754 398.807Z",
    fill: "#FCD1A9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M143.622 357.257C146.713 344.81 153.752 351.935 152.98 333.392C149.374 332.877 136.497 341.032 132.891 340.517C130.745 353.909 131.174 362.237 131.26 372.967C131.518 383.441 132.205 390.652 132.72 399.408C133.149 401.125 137.012 400.954 137.012 399.924C138.815 392.197 140.274 382.84 139.416 373.397C140.446 368.246 142.42 362.752 143.622 357.257Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M151.092 352.622C145.254 356.227 135.982 358.459 130.059 355.798C129.458 352.364 134.781 329.443 131.261 323.433C130.488 322.146 127.999 323.176 127.312 321.802C125.595 318.111 123.878 310.385 123.878 309.269C123.878 306.779 125.852 304.204 127.913 302.83C130.746 300.941 134.781 298.452 138.3 299.139C146.027 301.285 151.521 321.287 157.187 344.466C156.757 346.956 154.611 350.475 151.092 352.622Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M135.124 329.185C135.467 326.352 132.548 321.287 130.831 320.686C129.114 320.085 127.655 319.485 127.655 317.51C127.655 315.536 128.428 312.531 127.998 310.213L123.706 309.955C124.135 312.445 125.509 318.368 126.968 321.545C127.655 323.004 130.145 321.888 130.917 323.176C134.437 329.185 129.114 352.107 129.715 355.54C129.715 355.54 131.862 344.552 132.548 340.174C133.235 335.881 134.78 332.018 135.124 329.185Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M137.098 300.77C134.694 299.225 134.866 297.937 135.123 295.619C135.553 294.417 135.724 293.044 135.638 291.67C135.467 286.605 132.033 282.313 128.084 282.742C120.1 283.6 121.731 287.721 121.903 292.786C122.075 297.508 124.307 300.598 127.912 301.027C127.912 301.8 127.741 302.487 126.71 303.259C129.372 304.719 133.492 303.946 135.209 303.259C136.84 302.658 138.214 301.886 137.098 300.77Z",
    fill: "#FCD1A9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M103.617 330.215C102.93 330.301 102.415 328.584 101.299 328.413C100.183 328.241 97.6937 327.898 97.7795 328.584C97.8654 329.185 99.9257 329.099 99.5823 329.357C98.8097 330.215 96.8352 329.357 96.3201 328.584C95.805 327.812 95.2041 327.812 95.2041 328.498C95.2899 329.271 95.7192 332.619 98.4663 333.392C101.213 334.164 104.39 333.735 104.39 333.735L103.617 330.215Z",
    fill: "#FCD1A9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M103.531 334.165C103.531 334.165 101.128 332.533 103.36 329.786C111.257 328.413 121.13 319.399 123.534 308.754C124.993 304.633 129.629 307.466 128.685 312.789C127.139 321.116 117.524 333.821 103.531 334.165Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M120.872 289.61C121.044 286.691 123.362 281.712 128.685 282.055C133.75 282.398 135.896 286.004 135.982 290.382C135.982 293.816 139.072 303.603 146.884 303.002C143.536 309.269 119.842 310.299 120.872 289.61Z",
    fill: "#F2C94C"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M480.316 216.639H469.585L476.281 220.674L469.585 224.537H480.316L487.184 220.588L480.316 216.639Z",
    fill: "url(#paint34_linear)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M447.178 184.447H432.069L441.513 190.027L432.069 195.521H447.178L456.793 189.941L447.178 184.447Z",
    fill: "url(#paint35_linear)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M432.07 195.521L441.514 190.027V178.952L432.07 184.447V195.521Z",
    fill: "#292929"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M432.07 195.521L422.713 190.027V178.952L432.07 184.447V195.521Z",
    fill: "#313131"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M432.07 184.447L422.713 178.952L432.07 173.544L441.513 178.952L432.07 184.447Z",
    fill: "#C0162E"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M469.585 224.537L476.281 220.674V212.69L469.585 216.639V224.537Z",
    fill: "#292929"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M469.585 224.537L462.803 220.674V212.69L469.585 216.639V224.537Z",
    fill: "#CACACB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M469.585 216.639L462.803 212.69L469.585 208.827L476.281 212.69L469.585 216.639Z",
    fill: "#F1ECEC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M427.177 237.758H405.801L419.193 245.742L405.801 253.468H427.177L440.741 245.57L427.177 237.758Z",
    fill: "url(#paint36_linear)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M405.801 253.468L419.193 245.742V230.032L405.801 237.758V253.468Z",
    fill: "#292929"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M405.8 253.468L392.494 245.742V230.032L405.8 237.758V253.468Z",
    fill: "#313131"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M405.8 237.758L392.494 230.032L405.8 222.391L419.193 230.032L405.8 237.758Z",
    fill: "#F1ECEC"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M410.951 230.032L405.8 227.113L400.735 230.032L405.8 233.036L410.951 230.032Z",
    fill: "#292929"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6826 302.916H13.3066L26.6988 310.9L13.3066 318.626H34.6826L48.2465 310.814L34.6826 302.916Z",
    fill: "url(#paint37_linear)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3066 318.626L26.6988 310.9V295.275L13.3066 302.916V318.626Z",
    fill: "#292929"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3063 318.626L0 310.9V295.275L13.3063 302.916V318.626Z",
    fill: "#313131"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3063 302.916L0 295.275L13.3063 287.549L26.6985 295.275L13.3063 302.916Z",
    fill: "#313131"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M18.457 295.275L13.3062 292.271L8.24121 295.275L13.3062 298.194L18.457 295.275Z",
    fill: "url(#paint38_linear)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3659 231.521H1L7.46828 235.098L1 238.521H11.3659L18 235.021L11.3659 231.521Z",
    fill: "url(#paint39_linear)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M363.134 178.523C364.679 180.669 362.79 183.932 366.053 184.361C370.517 184.876 379.788 186.25 379.874 184.018C379.96 182.129 373.607 180.755 370.603 179.468C366.482 177.751 366.053 176.291 366.053 176.291L363.134 178.523Z",
    fill: "#C0162E"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M365.967 176.291C365.967 176.291 366.396 177.751 370.517 179.468C371.289 179.811 372.234 180.154 373.264 180.498C373.264 180.498 373.779 180.669 373.693 181.614C373.435 183.417 365.623 182.902 363.906 181.785C363.735 180.841 363.821 179.553 363.134 178.609L365.967 176.291Z",
    fill: "#FFCEA2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M359.443 179.725C359.529 180.412 360.731 182.644 361.503 183.76C362.19 184.704 364.766 187.795 365.023 188.138C366.225 189.34 365.366 190.456 363.564 190.456C361.761 190.456 360.559 190.37 359.701 189.855C358.499 189.168 354.378 186.249 354.636 184.447C354.807 183.502 354.979 183.502 355.322 181.27C355.408 180.669 355.494 179.21 355.494 179.21L359.443 179.725Z",
    fill: "#C0162E"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M358.584 186.078C357.296 185.391 355.579 184.017 354.979 182.987C355.064 182.644 355.15 182.129 355.236 181.442C355.322 180.841 355.408 179.382 355.408 179.382L359.357 179.725C359.443 180.412 360.644 182.644 361.417 183.76C361.675 184.103 362.104 184.704 362.705 185.391C363.048 186.679 359.872 186.765 358.584 186.078Z",
    fill: "#FFCEA2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M347.167 150.794C344.763 149.507 323.816 136.286 323.816 136.286L311.969 135.256C310.939 137.316 307.334 144.957 312.57 149.335C317.807 153.713 334.633 157.491 342.789 158.349L348.025 151.395C347.596 151.052 347.338 150.88 347.167 150.794Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M347.94 151.31L342.703 158.263C344.506 163.5 362.963 178.695 362.963 178.695C364.508 178.266 365.109 177.579 366.483 176.635C365.109 174.231 351.46 155.173 347.94 151.31Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M326.134 131.822C326.134 131.822 314.802 135.771 317.807 138.518C320.726 141.265 341.587 149.078 348.798 149.85L354.807 144.957C350.944 140.321 328.538 132.767 326.134 131.822Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M354.807 144.957L348.797 149.85C347.853 156.289 353.862 173.458 355.322 179.811C356.867 180.841 358.498 180.584 359.7 179.553C359.7 179.553 358.584 149.421 354.807 144.957Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M339.611 130.964C339.268 130.706 338.581 130.706 338.237 130.964L315.402 144.184C315.059 144.442 315.059 144.785 315.402 144.957L331.026 153.971C331.37 154.228 332.056 154.228 332.4 153.971L355.235 140.75C355.579 140.493 355.579 140.149 355.235 139.978L339.611 130.964Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M332.314 152.082L331.198 152.769L331.799 153.027L332.915 152.426L332.314 152.082Z",
    fill: "url(#paint40_linear)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M334.203 150.966L333.087 151.653L333.688 151.996L334.804 151.31L334.203 150.966Z",
    fill: "url(#paint41_linear)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M336.092 149.936L334.976 150.537L335.577 150.88L336.693 150.279L336.092 149.936Z",
    fill: "url(#paint42_linear)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M337.979 148.82L336.863 149.507L337.464 149.764L338.58 149.163L337.979 148.82Z",
    fill: "url(#paint43_linear)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M339.869 147.704L338.753 148.391L339.354 148.734L340.47 148.047L339.869 147.704Z",
    fill: "url(#paint44_linear)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M341.758 146.674L340.642 147.275L341.243 147.618L342.359 146.931L341.758 146.674Z",
    fill: "url(#paint45_linear)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M343.646 145.558L342.53 146.245L343.131 146.502L344.247 145.901L343.646 145.558Z",
    fill: "url(#paint46_linear)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M345.535 144.442L344.419 145.129L345.02 145.472L346.136 144.785L345.535 144.442Z",
    fill: "url(#paint47_linear)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M347.423 143.412L346.307 144.013L346.822 144.356L347.938 143.669L347.423 143.412Z",
    fill: "url(#paint48_linear)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M349.311 142.296L348.195 142.982L348.71 143.24L349.826 142.639L349.311 142.296Z",
    fill: "url(#paint49_linear)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M351.201 141.18L350.085 141.866L350.6 142.21L351.716 141.523L351.201 141.18Z",
    fill: "url(#paint50_linear)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M353.09 140.149L351.974 140.75L352.489 141.094L353.605 140.407L353.09 140.149Z",
    fill: "url(#paint51_linear)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M331.371 150.451L329.311 151.653L330.427 152.254L332.487 151.138L331.371 150.451Z",
    fill: "url(#paint52_linear)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M330.34 148.991L327.507 150.623L328.623 151.223L331.456 149.678L330.34 148.991Z",
    fill: "url(#paint53_linear)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M329.224 147.446L325.618 149.507L326.734 150.193L330.34 148.133L329.224 147.446Z",
    fill: "url(#paint54_linear)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M325.361 147.017L323.387 148.219L324.932 149.077L326.906 147.876L325.361 147.017Z",
    fill: "url(#paint55_linear)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M328.194 145.472L326.134 146.588L327.679 147.446L329.654 146.33L328.194 145.472Z",
    fill: "url(#paint56_linear)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M330.941 143.841L328.967 144.957L330.426 145.901L332.487 144.699L330.941 143.841Z",
    fill: "url(#paint57_linear)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M340.555 138.346L338.495 139.462L340.04 140.321L342.015 139.205L340.555 138.346Z",
    fill: "url(#paint58_linear)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M345.192 135.599L341.243 137.831L342.788 138.776L346.737 136.458L345.192 135.599Z",
    fill: "url(#paint59_linear)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M337.723 139.892L331.714 143.411L333.259 144.27L339.268 140.75L337.723 139.892Z",
    fill: "url(#paint60_linear)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M333.775 149.077L332.144 150.022L333.26 150.708L334.891 149.764L333.775 149.077Z",
    fill: "url(#paint61_linear)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M332.744 147.618L331.113 148.562L332.229 149.249L333.86 148.219L332.744 147.618Z",
    fill: "url(#paint62_linear)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M331.628 146.073L329.997 147.103L331.113 147.704L332.744 146.76L331.628 146.073Z",
    fill: "url(#paint63_linear)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M334.031 144.699L332.4 145.644L333.516 146.33L335.147 145.386L334.031 144.699Z",
    fill: "url(#paint64_linear)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M336.522 143.326L334.805 144.27L335.921 144.957L337.638 144.012L336.522 143.326Z",
    fill: "url(#paint65_linear)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M338.925 141.952L337.208 142.896L338.41 143.497L340.041 142.553L338.925 141.952Z",
    fill: "url(#paint66_linear)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M341.328 140.579L339.697 141.523L340.813 142.124L342.444 141.18L341.328 140.579Z",
    fill: "url(#paint67_linear)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M343.733 139.119L342.102 140.063L343.218 140.75L344.849 139.806L343.733 139.119Z",
    fill: "url(#paint68_linear)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M347.51 136.973L344.505 138.69L345.621 139.377L348.711 137.574L347.51 136.973Z",
    fill: "url(#paint69_linear)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M335.148 146.244L333.517 147.189L334.633 147.79L336.264 146.845L335.148 146.244Z",
    fill: "url(#paint70_linear)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M337.551 144.785L335.92 145.815L337.036 146.416L338.667 145.472L337.551 144.785Z",
    fill: "url(#paint71_linear)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M339.955 143.411L338.324 144.356L339.44 145.042L341.071 144.098L339.955 143.411Z",
    fill: "url(#paint72_linear)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M342.36 142.038L340.729 142.982L341.845 143.669L343.476 142.725L342.36 142.038Z",
    fill: "url(#paint73_linear)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M344.763 140.664L343.132 141.609L344.248 142.21L345.879 141.265L344.763 140.664Z",
    fill: "url(#paint74_linear)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M349.398 138.003L345.535 140.235L346.651 140.836L350.514 138.604L349.398 138.003Z",
    fill: "url(#paint75_linear)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M336.178 147.704L334.547 148.648L335.663 149.335L337.294 148.391L336.178 147.704Z",
    fill: "url(#paint76_linear)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M338.581 146.33L336.95 147.275L338.066 147.876L339.697 146.931L338.581 146.33Z",
    fill: "url(#paint77_linear)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M340.985 144.957L339.354 145.901L340.47 146.502L342.101 145.558L340.985 144.957Z",
    fill: "url(#paint78_linear)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M343.389 143.497L341.758 144.442L342.874 145.128L344.505 144.184L343.389 143.497Z",
    fill: "url(#paint79_linear)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M345.793 142.124L344.162 143.068L345.278 143.755L346.909 142.811L345.793 142.124Z",
    fill: "url(#paint80_linear)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M348.197 140.75L346.565 141.695L347.681 142.295L349.398 141.351L348.197 140.75Z",
    fill: "url(#paint81_linear)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M351.201 139.033L348.969 140.321L350.085 140.922L352.317 139.72L351.201 139.033Z",
    fill: "url(#paint82_linear)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M352.231 141.866L334.203 152.254L334.718 152.597L352.832 142.124L352.231 141.866Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M337.724 138.518L328.538 143.927L322.786 140.579L331.972 135.256L337.724 138.518Z",
    fill: "url(#paint83_linear)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M315.403 144.957L331.027 153.971C331.285 154.142 331.8 154.142 332.143 154.057L332.401 153.971L355.236 140.75C355.236 140.75 355.322 140.75 355.322 140.664C355.322 140.664 355.322 140.664 355.322 140.579C355.322 140.493 355.408 140.493 355.408 140.407V140.75C355.408 140.922 355.322 141.008 355.15 141.179L332.315 154.314C331.8 154.572 331.027 154.572 330.77 154.486C330.512 154.4 330.34 154.4 330.083 154.314L315.403 145.815C315.231 145.729 315.145 145.558 315.145 145.386V144.528C315.06 144.699 315.145 144.871 315.403 144.957Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M326.478 87.3533C329.482 91.7315 330.083 101.604 327.336 107.957C325.276 107.957 322.014 105.124 319.009 106.154C318.236 106.411 322.7 87.3533 326.478 87.3533Z",
    fill: "#F2C94C"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M339.27 132.337C340.815 133.196 344.249 133.711 345.193 134.569C346.137 135.428 346.395 138.003 345.622 138.776C344.85 139.549 344.077 139.549 344.506 138.776C344.936 138.003 344.85 136.458 343.648 136.372C341.416 136.115 344.249 138.604 343.133 138.69C342.103 138.69 341.673 137.402 340.472 136.544C339.27 135.6 338.411 135.342 337.295 134.312C336.265 133.368 339.27 132.337 339.27 132.337Z",
    fill: "#FACFA7"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M339.698 132.509C337.809 131.221 331.886 125.555 330.77 123.667C329.826 121.95 328.195 112.163 328.023 110.961C327.937 109.674 327.079 104.437 322.014 104.694C321.498 108.128 325.877 124.354 327.508 126.5C329.568 129.075 335.492 133.024 337.294 134.226C339.269 133.453 339.698 132.509 339.698 132.509Z",
    fill: "#FFCEA2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M360.817 130.363L338.754 143.068C338.411 143.24 338.067 143.583 337.896 143.927L332.23 153.542C332.144 153.713 332.316 153.885 332.487 153.799L355.495 140.579C355.666 140.493 355.838 140.321 355.924 140.149L361.246 131.135C361.676 130.449 361.418 130.105 360.817 130.363Z",
    fill: "#292929"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M332.229 153.627L337.895 144.012C338.067 143.669 338.41 143.326 338.754 143.154L360.816 130.449C361.074 130.277 361.246 130.277 361.331 130.449C361.331 130.449 361.16 130.277 360.988 130.105C360.902 130.019 360.731 130.019 360.473 130.105L338.41 142.811C338.067 142.982 337.723 143.326 337.552 143.669L331.886 153.284C331.8 153.37 331.886 153.456 331.886 153.541C331.972 153.627 332.143 153.799 332.143 153.799C332.143 153.799 332.143 153.713 332.229 153.627Z",
    fill: "#292929"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M311.883 134.226C312.742 126.672 309.308 117.4 308.621 112.678C308.192 109.674 307.934 106.154 310.595 105.296C313.428 104.437 314.544 104.008 316.948 104.094C322.786 104.265 325.533 105.467 326.735 109.502C327.851 113.279 328.623 114.481 329.568 118.173C329.997 119.804 325.79 124.955 326.305 132.166C328.022 138.776 309.823 139.806 311.883 134.226Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M314.974 97.0541C315.06 95.2513 321.241 98.8569 321.069 101.175C320.983 103.149 320.726 105.038 321.413 105.295C322.271 105.896 323.645 109.931 322.185 111.476C316.949 109.33 315.317 107.184 310.682 105.381C312.57 104.952 314.631 102.892 314.974 97.0541Z",
    fill: "#FFCEA2"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M328.537 139.463C330.855 141.094 331.542 140.064 332.744 140.665C334.031 141.265 335.233 142.124 335.663 142.381C336.092 142.639 334.632 142.639 334.031 142.381C335.491 143.583 335.577 145.129 335.319 145.815C334.976 146.588 333.001 147.361 332.486 146.931C330.512 145.043 330.855 144.356 328.194 143.583C327.25 143.326 325.876 141.952 325.876 141.952L328.537 139.463Z",
    fill: "#FACFA7"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M328.538 139.463C324.932 137.316 318.15 129.418 317.549 126.5C317.034 123.581 313.858 105.81 309.737 106.154C305.702 106.497 310.595 123.323 313.428 129.504C314.802 132.509 321.756 139.634 325.876 141.952C327.507 142.038 328.538 139.463 328.538 139.463Z",
    fill: "#FFCEA2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M313.429 94.5645L315.317 89.9288L324.761 88.4694C324.761 88.4694 325.362 88.126 326.392 88.126C327.851 91.0448 327.078 97.0541 327.078 97.0541C327.078 100.917 324.417 104.094 321.241 104.094C318.064 104.094 315.575 101.089 315.403 97.3975H314.545L313.429 94.5645Z",
    fill: "#FFCEA2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M316.348 100.917C317.378 102.72 319.009 103.922 320.898 104.008C320.898 104.609 320.983 104.952 321.241 105.21C320.898 105.21 320.64 105.21 320.297 105.124C318.322 104.609 316.949 102.978 316.348 100.917Z",
    fill: "#FBC096"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M320.725 84.7778C311.711 84.7778 309.994 95.8521 308.449 105.467C309.823 108.472 313.171 110.704 317.291 111.734C322.185 112.249 315.66 95.4229 322.528 91.0447C324.417 89.8428 327.937 90.3579 327.25 88.8127C325.705 85.3788 323.816 84.7778 320.725 84.7778Z",
    fill: "#F2C94C"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2778 253.521H44L53.5486 259.064L44 264.521H59.2778L69 258.979L59.2778 253.521Z",
    fill: "url(#paint84_linear)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7822 264.199L53.2254 258.705V247.63L43.7822 253.124V264.199Z",
    fill: "#292929"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7822 264.199L34.4248 258.705V247.63L43.7822 253.124V264.199Z",
    fill: "#313131"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7822 253.125L34.4248 247.63L43.7822 242.222L53.2254 247.63L43.7822 253.125Z",
    fill: "#C0162E"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M406.579 399.5H370.094V406.196H406.579V399.5Z",
    fill: "url(#paint85_linear)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M422.548 389.885H386.062V396.581H422.548V389.885Z",
    fill: "url(#paint86_linear)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M390.44 394.52C390.44 389.284 387.091 389.112 387.091 389.112C387.091 389.112 385.289 389.112 382.37 387.91C379.451 386.708 375.416 387.138 377.648 391.344C377.648 391.43 377.734 391.43 377.734 391.516C377.906 391.773 378.078 391.945 378.507 392.203L385.804 396.495C386.834 397.01 390.44 395.551 390.44 394.52Z",
    fill: "#C0162E"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M390.44 394.005C390.354 395.121 386.92 396.495 385.804 395.894L378.507 391.602C378.249 391.43 377.82 391.172 377.477 390.829C377.562 391.001 377.562 391.087 377.648 391.258C377.648 391.344 377.734 391.344 377.734 391.43C377.906 391.687 378.078 391.859 378.507 392.117L385.804 396.409C386.834 397.01 390.01 395.722 390.44 394.692C390.44 394.606 390.44 394.52 390.44 394.52C390.44 394.349 390.44 394.177 390.44 394.005Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M389.067 388.425C388.208 388.425 385.204 389.198 385.204 389.198C385.204 389.198 385.204 389.627 384.946 389.971L384.86 390.056C384.259 390.486 383.658 391.087 385.032 392.031C386.234 392.718 387.092 392.288 387.607 391.859C387.779 391.516 388.037 391.172 388.466 390.915C388.809 390.657 389.067 390.571 389.238 390.571V390.486C389.238 390.486 389.41 388.425 389.067 388.425Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M388.81 336.659C385.547 336.745 377.306 336.831 373.958 336.917C375.16 346.789 377.649 355.803 379.281 365.418C381.083 374.776 383.058 381.3 384.775 389.026C385.376 390.486 388.294 389.885 388.895 388.511C389.325 381.386 389.926 372.629 387.779 364.388C388.209 355.632 388.981 345.673 388.81 336.659Z",
    fill: "#313131"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M373.785 404.135C373.785 398.899 370.437 398.727 370.437 398.727C370.437 398.727 368.634 398.727 365.716 397.525C362.797 396.323 358.762 396.752 360.994 400.959C360.994 401.045 361.08 401.045 361.08 401.131C361.252 401.388 361.423 401.56 361.852 401.817L369.149 406.11C370.265 406.711 373.785 405.251 373.785 404.135Z",
    fill: "#C0162E"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M373.785 403.706C373.699 404.822 370.265 406.196 369.149 405.595L361.852 401.302C361.595 401.131 361.166 400.873 360.822 400.53C360.908 400.701 360.908 400.787 360.994 400.959C360.994 401.045 361.08 401.045 361.08 401.131C361.251 401.388 361.423 401.56 361.852 401.817L369.149 406.11C370.18 406.711 373.356 405.423 373.785 404.393C373.785 404.307 373.785 404.221 373.785 404.221C373.785 403.964 373.785 403.878 373.785 403.706Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M372.497 398.04C371.639 398.04 368.634 398.813 368.634 398.813C368.634 398.813 368.634 399.242 368.377 399.585L368.291 399.671C367.69 400.1 367.089 400.701 368.463 401.646C369.665 402.333 370.523 401.903 371.038 401.474C371.21 401.131 371.467 400.787 371.897 400.53C372.24 400.272 372.497 400.186 372.669 400.186V400.1C372.669 400.1 372.841 398.04 372.497 398.04Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M378.679 360.525C379.623 356.232 390.01 355.717 389.324 338.977C386.061 338.462 369.579 346.188 366.402 345.759C365.973 355.717 366.917 364.989 367.003 374.776C367.261 384.219 368.119 391.087 368.549 398.984C368.978 400.53 371.897 400.444 372.755 399.156C374.386 392.203 376.361 383.704 375.588 375.205C376.447 370.483 377.648 365.504 378.679 360.525Z",
    fill: "#292929"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M381.77 306.441C393.359 314.167 394.733 329.62 388.466 339.32C388.466 339.406 389.839 317.687 381.77 306.441Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M382.285 348.42C375.245 352.369 367.863 352.369 365.287 347.562C366.231 338.462 367.09 331.079 365.287 322.409C365.802 317.601 366.231 316.914 365.545 314.081C365.802 313.137 368.635 311.163 370.781 309.188C373.013 307.128 374.559 305.153 375.76 304.896C385.375 302.921 390.097 320.091 389.324 338.462C388.638 343.355 385.805 346.532 382.285 348.42Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M381.169 306.012C380.311 305.067 380.568 302.578 380.998 300.517C381.427 299.487 381.684 298.285 381.77 296.998C381.942 292.448 379.109 288.327 375.503 288.499C368.292 288.756 369.408 292.62 369.322 297.169C369.236 301.376 371.039 304.381 374.216 304.982C374.216 305.668 372.928 307.214 371.984 308.072C374.302 309.446 377.821 308.845 379.109 308.244C380.568 307.643 382.114 307.042 381.169 306.012Z",
    fill: "#FCD1A9"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M366.145 350.91C367.004 351.854 368.635 352.112 369.665 350.996C370.781 349.794 370.18 348.42 370.781 348.077C372.498 346.961 372.927 345.931 372.584 344.901C371.21 345.759 369.837 347.133 368.635 346.274C367.433 345.416 365.888 344.3 365.802 343.012C363.999 343.441 363.913 347.304 364.858 348.85C365.716 350.395 366.145 350.91 366.145 350.91Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M368.549 347.905C369.407 350.051 368.806 351.339 366.66 351.597C361.252 348.85 358.161 341.123 358.076 336.831C357.904 329.706 361.338 320.863 365.716 313.824C366.746 312.364 370.008 312.88 371.639 315.026C373.786 317.944 372.927 322.065 371.639 323.782C368.463 328.847 364.943 332.624 364.6 336.659C364.256 340.522 365.802 345.416 368.549 347.905Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.629 327.04C382.631 326.456 380.753 326.165 378.613 326.953C376.472 327.742 374.876 327.282 374.876 327.282C376.146 327.739 377.459 327.521 378.074 327.334C378.688 327.146 379.487 326.783 380.941 326.656C382.396 326.529 383.629 327.04 383.629 327.04ZM376.23 327.14C377.316 327.192 378.739 326.678 378.739 326.678C378.739 326.678 378.604 326.458 378.229 326.357C377.854 326.255 377.283 326.123 377.283 326.123C375.449 325.6 375.548 324.152 375.78 323.47C375.974 322.896 376.492 322.697 376.492 322.697L376.791 321.87C374.694 322.601 374.097 324.29 374.575 325.65C375.053 327.009 376.23 327.14 376.23 327.14ZM376.407 326.554C376.432 326.416 376.653 326.343 376.9 326.392C377.147 326.44 377.326 326.592 377.3 326.731C377.274 326.869 377.054 326.942 376.807 326.893C376.56 326.845 376.381 326.693 376.407 326.554ZM376.406 326.925C376.385 327.006 376.252 327.041 376.108 327.004C375.963 326.966 375.863 326.87 375.884 326.79C375.904 326.709 376.038 326.674 376.182 326.711C376.326 326.748 376.426 326.844 376.406 326.925ZM375.985 326.037C376.187 326.144 376.299 326.322 376.237 326.434C376.174 326.546 375.959 326.55 375.758 326.443C375.556 326.335 375.443 326.158 375.506 326.045C375.569 325.933 375.783 325.93 375.985 326.037ZM375.047 325.195C375.161 325.146 375.329 325.258 375.421 325.444C375.513 325.631 375.496 325.821 375.382 325.87C375.268 325.919 375.101 325.807 375.009 325.621C374.916 325.434 374.934 325.243 375.047 325.195ZM374.794 324.665C374.784 324.491 374.863 324.347 374.971 324.345C375.079 324.342 375.175 324.482 375.185 324.656C375.195 324.831 375.116 324.974 375.008 324.977C374.9 324.979 374.804 324.84 374.794 324.665ZM375.625 322.626C375.681 322.553 375.765 322.52 375.812 322.554C375.858 322.587 375.85 322.674 375.794 322.747C375.737 322.821 375.653 322.853 375.607 322.82C375.56 322.787 375.568 322.7 375.625 322.626ZM375.24 323.096C375.311 322.978 375.428 322.917 375.503 322.959C375.577 323.001 375.58 323.13 375.509 323.248C375.438 323.366 375.321 323.427 375.247 323.385C375.173 323.343 375.17 323.213 375.24 323.096ZM374.903 323.813C374.943 323.66 375.053 323.557 375.148 323.583C375.244 323.608 375.288 323.753 375.248 323.906C375.208 324.058 375.098 324.161 375.003 324.136C374.907 324.11 374.863 323.966 374.903 323.813ZM374.693 323.819C374.708 323.763 374.749 323.726 374.784 323.736C374.819 323.746 374.835 323.799 374.819 323.855C374.803 323.911 374.762 323.948 374.727 323.938C374.692 323.928 374.677 323.875 374.693 323.819ZM374.55 324.264C374.569 324.154 374.64 324.074 374.709 324.087C374.778 324.099 374.819 324.199 374.8 324.31C374.781 324.421 374.71 324.501 374.641 324.488C374.572 324.475 374.531 324.375 374.55 324.264ZM374.545 324.683C374.547 324.625 374.578 324.58 374.614 324.582C374.65 324.585 374.678 324.634 374.675 324.692C374.673 324.75 374.642 324.795 374.606 324.793C374.57 324.79 374.542 324.741 374.545 324.683ZM374.63 324.907C374.699 324.899 374.771 324.982 374.79 325.094C374.809 325.206 374.768 325.304 374.699 325.313C374.63 325.321 374.559 325.237 374.54 325.126C374.521 325.014 374.561 324.916 374.63 324.907ZM374.683 325.693C374.638 325.587 374.653 325.483 374.718 325.459C374.782 325.435 374.871 325.501 374.917 325.607C374.962 325.712 374.947 325.817 374.882 325.841C374.818 325.865 374.729 325.798 374.683 325.693ZM375.193 326.326C375.134 326.36 375.035 326.308 374.972 326.211C374.909 326.113 374.906 326.007 374.965 325.973C375.024 325.94 375.123 325.991 375.186 326.088C375.249 326.186 375.252 326.292 375.193 326.326ZM375.267 326.443C375.299 326.385 375.41 326.383 375.515 326.438C375.619 326.494 375.678 326.586 375.645 326.644C375.613 326.702 375.502 326.704 375.397 326.649C375.292 326.593 375.234 326.501 375.267 326.443ZM378.795 324.303C379.212 325.564 378.847 326.63 378.847 326.63C379.359 326.453 380.386 326.286 380.386 326.286C380.852 324.87 379.611 323.196 379.372 322.711C379.134 322.225 378.976 321.433 379.132 321.043C379.289 320.653 379.893 320.301 379.918 320.062C379.942 319.824 379.852 319.863 379.852 319.863C379.739 320.284 379.013 320.213 378.558 321.004C378.104 321.796 378.378 323.043 378.795 324.303ZM379.981 325.873C379.966 326.092 379.845 326.259 379.709 326.247C379.574 326.235 379.475 326.048 379.489 325.829C379.503 325.611 379.625 325.444 379.761 325.456C379.896 325.468 379.995 325.655 379.981 325.873ZM379.405 323.867C379.49 323.845 379.593 323.94 379.636 324.077C379.678 324.215 379.644 324.344 379.56 324.366C379.475 324.387 379.372 324.293 379.33 324.155C379.287 324.018 379.321 323.889 379.405 323.867ZM379.753 325.215C379.641 325.223 379.534 325.084 379.514 324.904C379.493 324.724 379.566 324.571 379.678 324.562C379.789 324.554 379.896 324.693 379.917 324.873C379.937 325.054 379.864 325.207 379.753 325.215ZM380.348 325.889C380.344 326.052 380.282 326.19 380.209 326.196C380.135 326.202 380.078 326.074 380.081 325.91C380.084 325.747 380.146 325.609 380.22 325.604C380.294 325.598 380.351 325.725 380.348 325.889ZM380.302 325.098C380.323 325.261 380.283 325.406 380.211 325.422C380.139 325.438 380.064 325.319 380.043 325.156C380.021 324.993 380.062 324.848 380.134 324.832C380.205 324.816 380.281 324.935 380.302 325.098ZM380.065 324.35C380.11 324.471 380.099 324.588 380.04 324.611C379.982 324.634 379.898 324.554 379.853 324.433C379.808 324.312 379.818 324.195 379.877 324.172C379.935 324.149 380.02 324.229 380.065 324.35ZM379.656 323.611C379.711 323.59 379.788 323.663 379.83 323.775C379.872 323.887 379.862 323.995 379.807 324.016C379.753 324.038 379.676 323.964 379.634 323.853C379.592 323.741 379.602 323.633 379.656 323.611ZM379.337 323.119C379.388 323.093 379.469 323.14 379.517 323.223C379.566 323.307 379.564 323.396 379.513 323.422C379.462 323.448 379.381 323.401 379.333 323.317C379.284 323.234 379.286 323.145 379.337 323.119ZM379.305 323.41C379.362 323.529 379.349 323.65 379.276 323.679C379.203 323.709 379.098 323.637 379.042 323.518C378.985 323.399 378.998 323.278 379.071 323.248C379.144 323.218 379.248 323.291 379.305 323.41ZM379.172 322.698C379.232 322.801 379.23 322.911 379.167 322.943C379.104 322.975 379.005 322.917 378.945 322.814C378.885 322.711 378.887 322.601 378.95 322.569C379.013 322.538 379.112 322.595 379.172 322.698ZM378.717 322.163C378.771 322.141 378.85 322.194 378.893 322.282C378.936 322.37 378.928 322.46 378.874 322.483C378.82 322.506 378.741 322.453 378.698 322.364C378.655 322.276 378.663 322.186 378.717 322.163ZM378.927 322.892C378.987 322.995 378.985 323.105 378.922 323.137C378.859 323.169 378.76 323.111 378.7 323.008C378.64 322.905 378.642 322.795 378.705 322.764C378.768 322.732 378.867 322.789 378.927 322.892ZM378.634 322.652C378.573 322.669 378.497 322.603 378.464 322.504C378.431 322.405 378.453 322.311 378.514 322.294C378.575 322.277 378.651 322.344 378.684 322.443C378.717 322.542 378.694 322.636 378.634 322.652ZM378.47 321.858C378.518 321.844 378.578 321.897 378.605 321.975C378.631 322.054 378.613 322.128 378.565 322.141C378.517 322.154 378.457 322.102 378.431 322.023C378.405 321.945 378.422 321.871 378.47 321.858ZM376.664 320.103C376.589 320.38 376.812 320.217 376.82 319.983C376.829 319.749 376.655 319.69 376.455 319.511C376.255 319.332 376.35 318.995 376.797 318.987C377.245 318.98 377.528 319.459 377.422 320.482C377.315 321.505 376.573 322.301 376.449 323.858C376.325 325.415 376.864 325.791 376.864 325.791C376.864 325.791 377.126 325.973 377.741 326.09C378.357 326.207 378.59 326.348 378.59 326.348C378.59 326.348 378.483 325.8 378.146 324.827C377.81 323.855 378.007 321.918 378.138 321.239C378.27 320.559 378.158 319.062 377.217 318.74C376.275 318.419 375.839 319.18 376.111 319.588C376.383 319.996 376.739 319.826 376.664 320.103ZM377.134 321.803C377.157 321.727 377.206 321.671 377.242 321.679C377.278 321.686 377.288 321.754 377.264 321.83C377.24 321.906 377.192 321.961 377.156 321.954C377.12 321.946 377.11 321.879 377.134 321.803ZM376.969 322.246C376.989 322.16 377.039 322.095 377.079 322.1C377.12 322.106 377.136 322.181 377.115 322.267C377.095 322.354 377.046 322.419 377.005 322.413C376.965 322.407 376.948 322.333 376.969 322.246ZM377.132 323.256C377.233 323.263 377.309 323.401 377.302 323.563C377.295 323.726 377.208 323.852 377.107 323.845C377.006 323.838 376.93 323.7 376.937 323.538C376.944 323.375 377.031 323.249 377.132 323.256ZM376.803 322.73C376.826 322.634 376.881 322.562 376.926 322.568C376.971 322.575 376.988 322.658 376.966 322.754C376.943 322.85 376.888 322.922 376.843 322.916C376.798 322.909 376.78 322.826 376.803 322.73ZM376.648 324.251C376.715 324.238 376.785 324.348 376.804 324.497C376.824 324.646 376.786 324.778 376.719 324.79C376.653 324.803 376.583 324.693 376.563 324.544C376.544 324.395 376.582 324.264 376.648 324.251ZM376.883 325.555C376.817 325.578 376.73 325.474 376.689 325.323C376.647 325.173 376.666 325.033 376.732 325.011C376.798 324.989 376.885 325.093 376.927 325.244C376.969 325.394 376.949 325.533 376.883 325.555ZM376.785 323.846C376.786 323.964 376.744 324.064 376.69 324.068C376.636 324.072 376.592 323.98 376.591 323.861C376.59 323.743 376.632 323.644 376.686 323.639C376.74 323.635 376.784 323.728 376.785 323.846ZM376.732 323.484C376.682 323.482 376.652 323.393 376.665 323.286C376.678 323.178 376.729 323.093 376.778 323.095C376.828 323.097 376.858 323.186 376.845 323.293C376.832 323.4 376.781 323.486 376.732 323.484ZM377.085 324.066C377.205 324.051 377.328 324.196 377.361 324.39C377.394 324.584 377.323 324.754 377.204 324.769C377.084 324.783 376.961 324.638 376.928 324.444C376.895 324.251 376.965 324.081 377.085 324.066ZM377.497 325.83C377.355 325.866 377.182 325.707 377.112 325.475C377.042 325.243 377.101 325.027 377.243 324.992C377.385 324.956 377.557 325.115 377.627 325.347C377.698 325.579 377.639 325.795 377.497 325.83ZM377.423 322.782C377.397 322.933 377.301 323.041 377.208 323.024C377.114 323.007 377.058 322.872 377.083 322.721C377.108 322.571 377.204 322.462 377.298 322.479C377.392 322.496 377.448 322.632 377.423 322.782ZM377.55 322.104C377.526 322.218 377.449 322.299 377.378 322.283C377.306 322.267 377.268 322.162 377.292 322.047C377.315 321.933 377.393 321.853 377.464 321.868C377.535 321.884 377.574 321.99 377.55 322.104ZM377.649 321.52C377.633 321.622 377.568 321.697 377.504 321.686C377.44 321.675 377.401 321.582 377.417 321.48C377.433 321.377 377.498 321.303 377.562 321.314C377.626 321.325 377.665 321.417 377.649 321.52ZM377.591 320.521C377.593 320.457 377.627 320.406 377.667 320.409C377.707 320.411 377.738 320.465 377.736 320.53C377.734 320.595 377.7 320.645 377.66 320.643C377.62 320.64 377.589 320.586 377.591 320.521ZM377.624 320.829C377.672 320.834 377.706 320.9 377.701 320.976C377.695 321.053 377.652 321.111 377.605 321.107C377.557 321.102 377.523 321.036 377.528 320.96C377.534 320.883 377.577 320.825 377.624 320.829ZM379.679 322.951L379.701 323.016L379.988 323.51C380.165 323.525 380.719 323.621 380.719 323.621C380.699 323.306 380.855 322.544 381.105 322.263C381.585 321.72 381.817 320.989 381.687 320.278C381.535 319.445 381.096 319.032 380.945 319.083C380.794 319.134 381.156 319.145 381.317 319.834C381.478 320.523 381.122 321.225 380.482 321.741C379.67 322.395 379.679 322.951 379.679 322.951ZM381.278 321.464C381.302 321.421 381.342 321.397 381.367 321.411C381.393 321.425 381.394 321.472 381.37 321.515C381.346 321.558 381.306 321.581 381.28 321.567C381.255 321.553 381.254 321.507 381.278 321.464ZM381.073 321.742C381.111 321.69 381.167 321.665 381.198 321.686C381.229 321.708 381.223 321.768 381.186 321.82C381.148 321.873 381.092 321.898 381.061 321.877C381.03 321.855 381.036 321.795 381.073 321.742ZM380.784 322.063C380.836 321.991 380.912 321.957 380.954 321.986C380.997 322.016 380.989 322.098 380.938 322.17C380.886 322.241 380.81 322.276 380.768 322.246C380.726 322.217 380.733 322.135 380.784 322.063ZM380.462 322.516C380.51 322.405 380.602 322.338 380.668 322.367C380.734 322.395 380.748 322.509 380.699 322.621C380.651 322.732 380.558 322.799 380.493 322.771C380.427 322.742 380.413 322.628 380.462 322.516ZM380.229 323.142C380.254 322.996 380.344 322.891 380.43 322.909C380.516 322.926 380.565 323.059 380.539 323.205C380.514 323.352 380.424 323.457 380.338 323.439C380.252 323.422 380.203 323.289 380.229 323.142ZM380.05 323.656C380.259 323.972 380.465 324.593 380.465 324.593C381.686 324.891 381.239 326.24 381.239 326.24C381.938 326.163 382.998 326.433 382.998 326.433C383.346 324.852 381.938 324.136 381.396 323.956C380.853 323.776 380.05 323.656 380.05 323.656ZM380.39 323.907C380.402 323.86 380.479 323.841 380.562 323.863C380.645 323.885 380.703 323.941 380.691 323.987C380.679 324.034 380.601 324.053 380.518 324.031C380.435 324.009 380.378 323.953 380.39 323.907ZM380.867 324.278C380.852 324.335 380.758 324.359 380.656 324.332C380.555 324.305 380.485 324.238 380.5 324.181C380.514 324.124 380.609 324.1 380.71 324.127C380.811 324.154 380.882 324.222 380.867 324.278ZM380.849 324.002C380.87 323.956 380.97 323.94 381.073 323.966C381.176 323.992 381.243 324.05 381.223 324.096C381.202 324.142 381.102 324.158 380.999 324.132C380.896 324.106 380.829 324.048 380.849 324.002ZM381.489 324.522C381.455 324.597 381.319 324.609 381.186 324.551C381.053 324.493 380.972 324.385 381.006 324.311C381.039 324.236 381.175 324.224 381.308 324.282C381.442 324.34 381.522 324.448 381.489 324.522ZM382.398 325.702C382.392 325.935 382.271 326.118 382.127 326.11C381.982 326.103 381.87 325.909 381.875 325.676C381.88 325.443 382.002 325.261 382.146 325.268C382.29 325.275 382.403 325.47 382.398 325.702ZM382.885 325.873C382.877 326.052 382.794 326.179 382.699 326.156C382.604 326.132 382.534 325.968 382.542 325.789C382.55 325.609 382.634 325.483 382.728 325.506C382.823 325.529 382.893 325.694 382.885 325.873ZM382.479 324.996C382.529 324.969 382.61 325.026 382.66 325.123C382.709 325.22 382.709 325.321 382.659 325.349C382.608 325.376 382.528 325.319 382.478 325.222C382.429 325.124 382.429 325.023 382.479 324.996ZM381.966 324.393C382.03 324.37 382.169 324.45 382.276 324.572C382.382 324.693 382.416 324.81 382.352 324.833C382.287 324.856 382.148 324.777 382.042 324.655C381.935 324.534 381.901 324.416 381.966 324.393ZM382.011 324.778C382.117 324.929 382.129 325.098 382.037 325.155C381.946 325.212 381.785 325.136 381.679 324.986C381.573 324.835 381.561 324.666 381.653 324.609C381.744 324.552 381.905 324.628 382.011 324.778ZM381.687 324.176C381.808 324.232 381.867 324.311 381.82 324.352C381.772 324.393 381.636 324.38 381.515 324.324C381.394 324.268 381.335 324.189 381.382 324.148C381.43 324.107 381.566 324.119 381.687 324.176ZM382.655 327.747C381.816 327.649 380.854 327.403 380.016 327.549C379.179 327.694 378.851 328.126 378.851 328.126C378.851 328.126 379.422 327.691 380.771 327.88C382.119 328.069 383.2 328.296 384.015 327.628C384.015 327.628 383.493 327.845 382.655 327.747Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.286 328.122C375.818 328.746 374.728 328.278 374.728 328.278C374.728 328.278 375.345 328.965 376.764 328.615C378.183 328.264 378.682 327.709 379.97 327.391C381.257 327.073 382.816 327.283 382.816 327.283C380.455 326.509 378.754 327.498 377.286 328.122ZM375.394 328.017C376.257 328.102 377.019 328.242 377.498 327.781C377.498 327.781 377.089 327.949 376.545 327.919C376.001 327.888 374.586 327.563 374.094 328.286C374.094 328.286 374.53 327.932 375.394 328.017Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.008 326.321L375.987 326.35L375.784 326.215L375.725 326.298L375.764 326.324L375.787 326.291L375.952 326.4L375.93 326.431L375.968 326.457L376.047 326.346L376.008 326.321Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.196 323.45L377.102 323.443L377.1 323.482L377.137 323.485L377.129 323.651L377.093 323.648L377.091 323.687L377.217 323.697L377.219 323.657L377.185 323.655L377.196 323.45Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.742 324.631L376.732 324.458L376.652 324.46L376.654 324.493L376.686 324.492L376.694 324.632L376.664 324.633L376.666 324.666L376.772 324.663L376.77 324.63L376.742 324.631Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.901 325.395L376.873 325.4L376.838 325.229L376.76 325.241L376.766 325.274L376.798 325.269L376.826 325.407L376.797 325.412L376.804 325.445L376.908 325.428L376.901 325.395Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.761 324.979L379.732 324.75L379.627 324.76L379.633 324.803L379.674 324.8L379.698 324.985L379.659 324.988L379.664 325.032L379.804 325.02L379.798 324.976L379.761 324.979Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.928 324.897L381.896 324.914L381.773 324.714L381.683 324.763L381.706 324.801L381.742 324.782L381.842 324.943L381.808 324.962L381.832 325L381.951 324.935L381.928 324.897Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.3 324.368L381.287 324.389L381.141 324.302L381.103 324.362L381.131 324.379L381.146 324.355L381.264 324.425L381.25 324.448L381.278 324.464L381.328 324.384L381.3 324.368Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.056 324.025L381.049 324.042L380.937 324L380.92 324.046L380.941 324.054L380.948 324.035L381.039 324.07L381.032 324.087L381.053 324.095L381.077 324.033L381.056 324.025Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.622 322.466L380.56 322.441L380.549 322.466L380.574 322.477L380.528 322.586L380.504 322.576L380.493 322.602L380.576 322.636L380.587 322.61L380.565 322.601L380.622 322.466Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.565 324.169L379.537 324.178L379.471 324.007L379.394 324.032L379.406 324.064L379.437 324.054L379.491 324.193L379.462 324.202L379.474 324.235L379.577 324.201L379.565 324.169Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.797 323.85L379.776 323.857L379.726 323.727L379.667 323.746L379.676 323.771L379.7 323.764L379.741 323.869L379.718 323.876L379.728 323.901L379.807 323.875L379.797 323.85Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.488 323.285L379.472 323.293L379.417 323.194L379.372 323.216L379.383 323.235L379.401 323.226L379.445 323.306L379.428 323.314L379.439 323.332L379.498 323.304L379.488 323.285Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.124 322.77L379.108 322.778L379.054 322.679L379.009 322.701L379.02 322.72L379.037 322.711L379.082 322.791L379.065 322.799L379.075 322.817L379.135 322.789L379.124 322.77Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.878 322.962L378.862 322.97L378.807 322.872L378.763 322.893L378.773 322.912L378.791 322.903L378.836 322.983L378.819 322.991L378.829 323.01L378.889 322.981L378.878 322.962Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.634 322.491L378.618 322.496L378.576 322.392L378.529 322.408L378.537 322.428L378.556 322.422L378.589 322.506L378.572 322.512L378.579 322.532L378.642 322.511L378.634 322.491Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.183 325.204L380.161 325.03L380.081 325.037L380.085 325.07L380.117 325.067L380.135 325.208L380.105 325.211L380.109 325.244L380.216 325.234L380.211 325.201L380.183 325.204Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.764 323.784L376.691 323.777L376.689 323.808L376.718 323.81L376.709 323.938L376.682 323.936L376.68 323.966L376.777 323.974L376.779 323.944L376.753 323.942L376.764 323.784Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.818 323.229L376.756 323.218L376.752 323.244L376.777 323.248L376.76 323.356L376.737 323.352L376.733 323.378L376.815 323.392L376.819 323.366L376.797 323.362L376.818 323.229Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.329 322.657L377.247 322.642L377.242 322.676L377.274 322.682L377.251 322.826L377.22 322.821L377.215 322.854L377.324 322.873L377.329 322.839L377.3 322.834L377.329 322.657Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.721 320.439L377.684 320.435L377.683 320.45L377.698 320.452L377.692 320.518L377.678 320.516L377.676 320.532L377.726 320.537L377.727 320.522L377.714 320.52L377.721 320.439Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.787 325.244L374.759 325.247L374.736 325.077L374.658 325.084L374.663 325.117L374.694 325.114L374.712 325.251L374.683 325.254L374.687 325.287L374.791 325.277L374.787 325.244Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.582 326.63L375.567 326.651L375.421 326.554L375.379 326.614L375.407 326.632L375.424 326.608L375.541 326.686L375.525 326.709L375.553 326.727L375.61 326.648L375.582 326.63Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.274 326.933L376.262 326.959L376.089 326.882L376.056 326.953L376.089 326.968L376.103 326.939L376.242 327.001L376.23 327.028L376.263 327.042L376.307 326.948L376.274 326.933Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.348 325.574C375.322 325.521 375.294 325.488 375.264 325.473C375.238 325.46 375.212 325.46 375.184 325.472C375.156 325.484 375.139 325.503 375.133 325.529C375.125 325.56 375.135 325.602 375.161 325.655C375.188 325.708 375.215 325.741 375.243 325.755C375.27 325.768 375.298 325.769 375.326 325.757C375.354 325.745 375.371 325.726 375.377 325.7C375.384 325.669 375.375 325.627 375.348 325.574ZM375.319 325.699C375.315 325.705 375.311 325.71 375.304 325.713C375.297 325.716 375.29 325.716 375.283 325.714C375.276 325.712 375.267 325.706 375.258 325.695C375.248 325.685 375.236 325.663 375.219 325.63C375.203 325.597 375.193 325.573 375.19 325.558C375.187 325.546 375.188 325.537 375.191 325.531C375.194 325.524 375.199 325.519 375.206 325.517C375.213 325.514 375.219 325.513 375.227 325.515C375.234 325.517 375.242 325.523 375.252 325.534C375.261 325.545 375.274 325.567 375.291 325.599C375.307 325.632 375.317 325.656 375.32 325.671C375.322 325.683 375.322 325.692 375.319 325.699Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.188 326.213C375.171 326.18 375.154 326.159 375.135 326.15C375.12 326.143 375.103 326.143 375.086 326.15C375.069 326.157 375.058 326.169 375.054 326.185C375.05 326.204 375.056 326.23 375.072 326.263C375.088 326.296 375.105 326.317 375.122 326.325C375.139 326.333 375.157 326.334 375.174 326.326C375.191 326.319 375.202 326.307 375.205 326.291C375.21 326.272 375.204 326.246 375.188 326.213ZM375.169 326.29C375.167 326.294 375.164 326.297 375.16 326.299C375.156 326.301 375.152 326.301 375.147 326.3C375.143 326.299 375.138 326.295 375.132 326.288C375.126 326.281 375.118 326.268 375.108 326.248C375.098 326.228 375.092 326.213 375.09 326.203C375.088 326.196 375.088 326.19 375.09 326.186C375.092 326.182 375.095 326.179 375.1 326.177C375.104 326.176 375.108 326.175 375.112 326.176C375.117 326.178 375.122 326.182 375.128 326.188C375.134 326.195 375.142 326.208 375.152 326.229C375.162 326.249 375.168 326.264 375.17 326.273C375.172 326.281 375.171 326.286 375.169 326.29Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.915 325.71C374.901 325.676 374.886 325.654 374.868 325.643C374.853 325.634 374.836 325.633 374.818 325.639C374.8 325.645 374.789 325.656 374.784 325.671C374.777 325.69 374.781 325.717 374.794 325.75C374.808 325.784 374.823 325.806 374.839 325.816C374.856 325.826 374.873 325.827 374.891 325.821C374.909 325.815 374.92 325.805 374.925 325.789C374.932 325.77 374.928 325.744 374.915 325.71ZM374.889 325.785C374.887 325.789 374.884 325.792 374.88 325.793C374.875 325.794 374.871 325.794 374.867 325.793C374.862 325.791 374.857 325.787 374.852 325.78C374.847 325.773 374.84 325.759 374.832 325.738C374.823 325.717 374.819 325.702 374.818 325.692C374.817 325.685 374.817 325.679 374.82 325.675C374.822 325.671 374.825 325.669 374.83 325.667C374.834 325.666 374.838 325.666 374.843 325.668C374.847 325.669 374.852 325.673 374.857 325.68C374.862 325.688 374.869 325.702 374.878 325.723C374.886 325.743 374.891 325.759 374.892 325.768C374.892 325.776 374.892 325.781 374.889 325.785Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.048 326.69C377.019 326.66 376.966 326.638 376.89 326.625C376.814 326.612 376.758 326.616 376.721 326.635C376.69 326.651 376.672 326.677 376.666 326.714C376.661 326.751 376.67 326.782 376.694 326.807C376.723 326.838 376.776 326.859 376.851 326.872C376.928 326.885 376.983 326.883 377.017 326.865C377.05 326.848 377.07 326.82 377.076 326.783C377.082 326.746 377.072 326.715 377.048 326.69ZM377.012 326.773C377.011 326.781 377.007 326.789 377 326.795C376.993 326.8 376.98 326.804 376.962 326.806C376.944 326.807 376.911 326.804 376.864 326.796C376.817 326.788 376.784 326.78 376.765 326.771C376.75 326.765 376.74 326.758 376.735 326.75C376.731 326.742 376.729 326.734 376.73 326.725C376.731 326.716 376.736 326.709 376.743 326.703C376.75 326.697 376.762 326.693 376.781 326.692C376.799 326.69 376.832 326.694 376.879 326.702C376.926 326.709 376.959 326.718 376.977 326.726C376.992 326.732 377.002 326.74 377.007 326.747C377.012 326.755 377.013 326.764 377.012 326.773Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.513 325.448C377.492 325.376 377.465 325.327 377.43 325.302C377.401 325.281 377.367 325.275 377.329 325.283C377.291 325.292 377.265 325.312 377.251 325.343C377.234 325.381 377.236 325.435 377.256 325.507C377.277 325.58 377.303 325.627 377.335 325.65C377.367 325.673 377.402 325.68 377.44 325.671C377.478 325.662 377.504 325.642 377.518 325.612C377.535 325.574 377.533 325.519 377.513 325.448ZM377.453 325.563C377.453 325.578 377.45 325.589 377.445 325.597C377.439 325.604 377.432 325.609 377.423 325.611C377.414 325.613 377.405 325.612 377.396 325.608C377.387 325.604 377.378 325.595 377.369 325.579C377.359 325.564 377.348 325.533 377.336 325.489C377.323 325.444 377.316 325.412 377.316 325.392C377.316 325.377 377.319 325.365 377.324 325.358C377.33 325.351 377.337 325.346 377.346 325.344C377.355 325.342 377.364 325.343 377.373 325.347C377.382 325.35 377.391 325.36 377.4 325.376C377.41 325.391 377.421 325.421 377.434 325.466C377.446 325.511 377.453 325.543 377.453 325.563Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.81 325.755C379.791 325.73 379.764 325.716 379.729 325.714C379.694 325.712 379.666 325.722 379.646 325.745C379.621 325.772 379.608 325.818 379.605 325.883C379.603 325.949 379.612 325.995 379.633 326.022C379.654 326.049 379.682 326.064 379.717 326.066C379.752 326.068 379.78 326.058 379.8 326.036C379.825 326.009 379.838 325.963 379.84 325.897C379.843 325.832 379.832 325.785 379.81 325.755ZM379.768 325.893C379.767 325.933 379.763 325.962 379.758 325.979C379.754 325.992 379.748 326 379.742 326.005C379.735 326.01 379.727 326.012 379.719 326.011C379.71 326.011 379.703 326.008 379.697 326.003C379.69 325.997 379.685 325.987 379.682 325.971C379.678 325.956 379.677 325.928 379.678 325.888C379.679 325.847 379.683 325.819 379.688 325.802C379.692 325.789 379.698 325.78 379.704 325.775C379.711 325.771 379.719 325.768 379.727 325.769C379.735 325.77 379.743 325.772 379.749 325.778C379.755 325.783 379.761 325.794 379.764 325.809C379.768 325.825 379.769 325.853 379.768 325.893Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.174 325.564C382.155 325.539 382.128 325.525 382.093 325.523C382.058 325.521 382.03 325.531 382.01 325.554C381.985 325.581 381.972 325.627 381.97 325.692C381.967 325.758 381.977 325.804 381.997 325.832C382.018 325.859 382.046 325.873 382.081 325.875C382.116 325.877 382.144 325.867 382.164 325.845C382.189 325.818 382.202 325.772 382.205 325.706C382.207 325.641 382.197 325.594 382.174 325.564ZM382.132 325.702C382.131 325.743 382.127 325.771 382.122 325.788C382.118 325.801 382.113 325.809 382.106 325.814C382.099 325.819 382.091 325.821 382.083 325.82C382.075 325.82 382.067 325.817 382.061 325.812C382.055 325.806 382.05 325.796 382.046 325.78C382.042 325.765 382.041 325.737 382.042 325.697C382.044 325.656 382.047 325.628 382.052 325.611C382.056 325.598 382.062 325.589 382.069 325.584C382.075 325.58 382.083 325.578 382.091 325.578C382.1 325.579 382.107 325.582 382.113 325.587C382.12 325.593 382.125 325.603 382.129 325.618C382.132 325.634 382.134 325.662 382.132 325.702Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.444 323.07C380.435 323.048 380.419 323.035 380.397 323.029C380.374 323.023 380.355 323.028 380.339 323.042C380.32 323.06 380.305 323.093 380.295 323.142C380.286 323.192 380.285 323.228 380.295 323.251C380.305 323.274 380.321 323.289 380.344 323.295C380.366 323.301 380.385 323.296 380.401 323.282C380.421 323.264 380.435 323.231 380.445 323.181C380.455 323.132 380.454 323.095 380.444 323.07ZM380.407 323.105C380.408 323.118 380.405 323.139 380.399 323.169C380.393 323.2 380.387 323.221 380.381 323.233C380.377 323.243 380.373 323.249 380.368 323.251C380.363 323.254 380.357 323.255 380.352 323.253C380.347 323.252 380.342 323.249 380.339 323.244C380.336 323.239 380.334 323.231 380.333 323.218C380.333 323.206 380.336 323.185 380.342 323.155C380.348 323.124 380.353 323.103 380.359 323.091C380.363 323.081 380.368 323.075 380.373 323.072C380.378 323.07 380.383 323.069 380.388 323.07C380.394 323.072 380.398 323.075 380.401 323.08C380.405 323.085 380.407 323.093 380.407 323.105Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.884 321.994C380.874 321.987 380.863 321.986 380.852 321.991C380.839 321.996 380.825 322.01 380.811 322.032C380.797 322.055 380.79 322.073 380.79 322.086C380.791 322.1 380.796 322.109 380.807 322.116C380.817 322.123 380.827 322.124 380.838 322.12C380.851 322.114 380.865 322.1 380.879 322.078C380.894 322.055 380.901 322.037 380.9 322.022C380.899 322.01 380.894 322.001 380.884 321.994ZM380.875 322.034C380.873 322.04 380.867 322.05 380.858 322.064C380.849 322.078 380.842 322.087 380.837 322.092C380.833 322.096 380.83 322.098 380.827 322.099C380.824 322.099 380.821 322.099 380.819 322.097C380.816 322.096 380.815 322.093 380.814 322.09C380.813 322.087 380.814 322.083 380.816 322.077C380.818 322.071 380.823 322.061 380.832 322.047C380.841 322.033 380.848 322.023 380.853 322.018C380.857 322.014 380.861 322.012 380.864 322.011C380.867 322.011 380.869 322.011 380.872 322.013C380.874 322.015 380.876 322.017 380.877 322.02C380.877 322.023 380.877 322.028 380.875 322.034Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.129 321.679C381.122 321.674 381.115 321.673 381.107 321.676C381.098 321.68 381.089 321.69 381.079 321.706C381.068 321.722 381.064 321.734 381.064 321.744C381.064 321.753 381.068 321.76 381.075 321.765C381.083 321.769 381.09 321.77 381.097 321.767C381.107 321.763 381.116 321.753 381.126 321.738C381.136 321.722 381.141 321.709 381.141 321.699C381.14 321.69 381.136 321.684 381.129 321.679ZM381.123 321.707C381.122 321.711 381.118 321.718 381.112 321.728C381.105 321.738 381.1 321.744 381.097 321.748C381.094 321.75 381.092 321.752 381.09 321.752C381.087 321.753 381.086 321.752 381.084 321.751C381.082 321.75 381.081 321.748 381.08 321.746C381.08 321.744 381.08 321.741 381.082 321.737C381.083 321.733 381.087 321.726 381.093 321.716C381.099 321.706 381.104 321.699 381.108 321.696C381.111 321.693 381.113 321.691 381.115 321.691C381.117 321.691 381.119 321.691 381.121 321.692C381.123 321.693 381.124 321.695 381.124 321.697C381.125 321.699 381.124 321.702 381.123 321.707Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.54 325.145C382.53 325.12 382.519 325.104 382.506 325.096C382.494 325.089 382.482 325.088 382.469 325.092C382.455 325.096 382.446 325.104 382.442 325.116C382.438 325.13 382.44 325.15 382.45 325.175C382.46 325.2 382.471 325.217 382.483 325.224C382.495 325.231 382.508 325.233 382.522 325.228C382.535 325.224 382.544 325.216 382.548 325.204C382.553 325.19 382.55 325.171 382.54 325.145ZM382.521 325.201C382.519 325.204 382.517 325.206 382.513 325.207C382.51 325.208 382.507 325.208 382.504 325.207C382.5 325.206 382.497 325.203 382.493 325.197C382.489 325.192 382.484 325.181 382.478 325.166C382.472 325.15 382.468 325.139 382.468 325.132C382.467 325.126 382.468 325.122 382.469 325.119C382.471 325.116 382.474 325.114 382.477 325.113C382.48 325.112 382.483 325.112 382.487 325.113C382.49 325.115 382.493 325.118 382.497 325.123C382.501 325.128 382.506 325.139 382.512 325.155C382.518 325.17 382.522 325.182 382.523 325.189C382.523 325.194 382.523 325.199 382.521 325.201Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.183 324.618C382.177 324.598 382.161 324.574 382.133 324.546C382.106 324.517 382.083 324.501 382.065 324.496C382.05 324.491 382.039 324.495 382.03 324.506C382.021 324.517 382.019 324.53 382.024 324.547C382.03 324.567 382.047 324.591 382.074 324.619C382.101 324.648 382.123 324.664 382.14 324.669C382.156 324.673 382.168 324.67 382.177 324.659C382.186 324.648 382.188 324.634 382.183 324.618ZM382.154 324.635C382.152 324.638 382.149 324.639 382.146 324.639C382.142 324.639 382.136 324.636 382.129 324.631C382.121 324.626 382.109 324.614 382.092 324.597C382.075 324.579 382.064 324.566 382.058 324.557C382.053 324.55 382.051 324.544 382.05 324.54C382.05 324.536 382.051 324.532 382.053 324.53C382.055 324.527 382.058 324.526 382.062 324.526C382.065 324.526 382.071 324.529 382.078 324.534C382.086 324.539 382.098 324.551 382.115 324.568C382.132 324.586 382.143 324.599 382.149 324.608C382.154 324.615 382.156 324.621 382.157 324.625C382.157 324.629 382.156 324.633 382.154 324.635Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.617 324.217C381.603 324.203 381.578 324.189 381.543 324.177C381.508 324.165 381.481 324.161 381.465 324.164C381.451 324.167 381.443 324.175 381.441 324.188C381.439 324.201 381.444 324.213 381.455 324.225C381.469 324.239 381.494 324.252 381.529 324.264C381.565 324.276 381.591 324.281 381.606 324.278C381.621 324.275 381.63 324.266 381.632 324.253C381.634 324.24 381.629 324.228 381.617 324.217ZM381.602 324.243C381.602 324.246 381.6 324.249 381.597 324.25C381.594 324.252 381.588 324.252 381.579 324.25C381.571 324.249 381.556 324.245 381.534 324.237C381.512 324.23 381.496 324.224 381.487 324.219C381.48 324.215 381.476 324.211 381.473 324.208C381.471 324.205 381.47 324.201 381.471 324.198C381.471 324.195 381.473 324.193 381.476 324.191C381.479 324.19 381.485 324.19 381.493 324.191C381.502 324.192 381.517 324.197 381.539 324.204C381.561 324.212 381.576 324.218 381.585 324.223C381.592 324.227 381.597 324.23 381.599 324.234C381.602 324.237 381.603 324.24 381.602 324.243Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.712 324.214C380.7 324.203 380.68 324.194 380.652 324.185C380.624 324.177 380.603 324.175 380.59 324.178C380.579 324.181 380.573 324.187 380.572 324.197C380.571 324.208 380.576 324.217 380.585 324.226C380.597 324.236 380.617 324.246 380.645 324.254C380.673 324.262 380.694 324.265 380.705 324.262C380.717 324.259 380.724 324.252 380.725 324.242C380.726 324.232 380.722 324.222 380.712 324.214ZM380.701 324.235C380.701 324.238 380.699 324.239 380.697 324.241C380.695 324.242 380.69 324.242 380.684 324.242C380.677 324.241 380.665 324.238 380.647 324.233C380.63 324.228 380.617 324.223 380.61 324.22C380.605 324.217 380.601 324.214 380.599 324.212C380.597 324.209 380.596 324.207 380.596 324.204C380.596 324.202 380.598 324.2 380.6 324.199C380.603 324.197 380.607 324.197 380.614 324.198C380.62 324.199 380.633 324.201 380.65 324.207C380.668 324.212 380.68 324.216 380.687 324.22C380.693 324.222 380.696 324.225 380.698 324.228C380.7 324.23 380.701 324.233 380.701 324.235Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.555 323.935C380.546 323.926 380.529 323.918 380.506 323.912C380.483 323.905 380.466 323.903 380.455 323.906C380.446 323.908 380.441 323.913 380.44 323.922C380.439 323.93 380.443 323.938 380.451 323.945C380.46 323.953 380.476 323.961 380.5 323.968C380.523 323.975 380.54 323.977 380.55 323.974C380.559 323.972 380.565 323.966 380.566 323.958C380.566 323.95 380.563 323.942 380.555 323.935ZM380.546 323.952C380.546 323.954 380.545 323.956 380.543 323.957C380.541 323.958 380.537 323.958 380.532 323.958C380.526 323.957 380.516 323.955 380.502 323.951C380.487 323.946 380.477 323.943 380.471 323.94C380.467 323.938 380.463 323.936 380.462 323.933C380.46 323.931 380.459 323.929 380.46 323.927C380.46 323.925 380.461 323.924 380.463 323.923C380.465 323.922 380.469 323.921 380.474 323.922C380.48 323.923 380.49 323.925 380.504 323.929C380.518 323.933 380.529 323.937 380.534 323.94C380.539 323.942 380.542 323.944 380.544 323.946C380.546 323.948 380.546 323.95 380.546 323.952Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.695 325.749C382.682 325.732 382.664 325.723 382.641 325.722C382.617 325.72 382.599 325.727 382.585 325.742C382.569 325.76 382.56 325.791 382.559 325.834C382.557 325.878 382.563 325.909 382.577 325.927C382.591 325.945 382.609 325.955 382.633 325.956C382.656 325.957 382.675 325.951 382.688 325.936C382.705 325.918 382.713 325.887 382.715 325.844C382.716 325.8 382.71 325.769 382.695 325.749ZM382.667 325.841C382.666 325.868 382.663 325.887 382.66 325.898C382.657 325.906 382.654 325.912 382.649 325.915C382.645 325.918 382.64 325.92 382.634 325.92C382.628 325.919 382.623 325.917 382.619 325.914C382.615 325.91 382.612 325.903 382.609 325.893C382.607 325.883 382.606 325.864 382.607 325.837C382.608 325.81 382.61 325.791 382.614 325.78C382.616 325.771 382.62 325.766 382.624 325.762C382.629 325.759 382.634 325.758 382.639 325.758C382.645 325.759 382.65 325.76 382.654 325.764C382.658 325.768 382.662 325.775 382.664 325.785C382.667 325.795 382.668 325.814 382.667 325.841Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.995 324.372C379.984 324.34 379.97 324.318 379.954 324.308C379.94 324.299 379.924 324.297 379.907 324.302C379.89 324.307 379.879 324.316 379.873 324.331C379.866 324.348 379.869 324.373 379.88 324.405C379.891 324.437 379.904 324.458 379.919 324.468C379.934 324.478 379.95 324.48 379.968 324.475C379.985 324.47 379.996 324.46 380.002 324.446C380.008 324.429 380.006 324.404 379.995 324.372ZM379.968 324.441C379.965 324.445 379.962 324.447 379.958 324.448C379.954 324.449 379.95 324.449 379.946 324.448C379.942 324.446 379.938 324.442 379.933 324.435C379.928 324.428 379.922 324.415 379.915 324.395C379.908 324.375 379.905 324.36 379.904 324.351C379.904 324.344 379.905 324.339 379.907 324.336C379.909 324.332 379.912 324.33 379.917 324.329C379.921 324.328 379.925 324.328 379.929 324.329C379.933 324.331 379.937 324.335 379.942 324.342C379.947 324.349 379.952 324.362 379.959 324.382C379.966 324.402 379.97 324.416 379.971 324.425C379.971 324.432 379.97 324.438 379.968 324.441Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.227 323.444C379.214 323.412 379.199 323.392 379.182 323.382C379.167 323.374 379.152 323.373 379.135 323.379C379.118 323.385 379.108 323.395 379.103 323.41C379.097 323.427 379.101 323.452 379.114 323.483C379.127 323.515 379.142 323.535 379.157 323.544C379.173 323.553 379.189 323.554 379.206 323.549C379.223 323.543 379.233 323.532 379.238 323.518C379.244 323.5 379.24 323.475 379.227 323.444ZM379.204 323.515C379.202 323.518 379.199 323.521 379.195 323.522C379.191 323.524 379.187 323.524 379.183 323.522C379.179 323.521 379.174 323.517 379.169 323.51C379.164 323.504 379.157 323.491 379.149 323.471C379.141 323.452 379.136 323.437 379.135 323.428C379.134 323.421 379.135 323.416 379.137 323.413C379.139 323.409 379.142 323.407 379.146 323.405C379.15 323.404 379.154 323.404 379.158 323.405C379.163 323.406 379.167 323.41 379.172 323.417C379.177 323.424 379.184 323.437 379.192 323.456C379.2 323.476 379.205 323.49 379.206 323.499C379.207 323.506 379.206 323.511 379.204 323.515Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.856 322.285C378.844 322.263 378.831 322.248 378.818 322.242C378.807 322.237 378.795 322.237 378.783 322.243C378.771 322.248 378.764 322.257 378.761 322.268C378.759 322.281 378.763 322.299 378.775 322.322C378.787 322.345 378.799 322.359 378.812 322.365C378.824 322.37 378.836 322.37 378.848 322.365C378.86 322.359 378.867 322.351 378.87 322.34C378.872 322.326 378.868 322.308 378.856 322.285ZM378.844 322.34C378.843 322.343 378.841 322.345 378.838 322.346C378.835 322.347 378.832 322.348 378.829 322.347C378.826 322.346 378.822 322.343 378.818 322.339C378.813 322.334 378.808 322.325 378.8 322.311C378.793 322.297 378.788 322.286 378.787 322.28C378.786 322.275 378.786 322.271 378.787 322.268C378.788 322.265 378.79 322.263 378.793 322.262C378.796 322.26 378.799 322.26 378.802 322.261C378.805 322.262 378.809 322.264 378.813 322.269C378.818 322.273 378.823 322.283 378.831 322.297C378.838 322.311 378.843 322.321 378.844 322.328C378.845 322.333 378.845 322.337 378.844 322.34Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.575 321.956C378.568 321.938 378.559 321.927 378.549 321.921C378.541 321.916 378.532 321.916 378.523 321.919C378.513 321.923 378.507 321.929 378.504 321.937C378.501 321.947 378.503 321.961 378.511 321.979C378.519 321.998 378.527 322.009 378.536 322.014C378.545 322.019 378.554 322.02 378.564 322.017C378.573 322.013 378.579 322.007 378.582 321.999C378.585 321.989 378.583 321.975 378.575 321.956ZM378.563 321.997C378.561 321.999 378.56 322.001 378.557 322.002C378.555 322.002 378.553 322.002 378.55 322.002C378.548 322.001 378.545 321.999 378.542 321.995C378.539 321.991 378.536 321.984 378.531 321.972C378.526 321.961 378.523 321.953 378.523 321.948C378.522 321.944 378.522 321.941 378.524 321.939C378.525 321.937 378.527 321.935 378.529 321.934C378.531 321.934 378.534 321.934 378.536 321.934C378.538 321.935 378.541 321.937 378.544 321.941C378.547 321.945 378.551 321.952 378.555 321.964C378.56 321.975 378.563 321.983 378.564 321.988C378.564 321.992 378.564 321.995 378.563 321.997Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.259 325.836C380.247 325.821 380.23 325.813 380.209 325.812C380.187 325.811 380.17 325.818 380.158 325.832C380.143 325.849 380.135 325.877 380.135 325.917C380.134 325.958 380.14 325.986 380.153 326.003C380.166 326.019 380.184 326.028 380.205 326.029C380.227 326.03 380.244 326.023 380.256 326.009C380.271 325.992 380.279 325.964 380.279 325.924C380.28 325.883 380.273 325.854 380.259 325.836ZM380.235 325.922C380.234 325.947 380.232 325.964 380.229 325.974C380.227 325.982 380.224 325.988 380.22 325.991C380.216 325.994 380.211 325.995 380.206 325.995C380.201 325.995 380.196 325.993 380.192 325.99C380.188 325.987 380.185 325.98 380.182 325.971C380.18 325.961 380.179 325.944 380.179 325.919C380.18 325.894 380.182 325.877 380.185 325.866C380.187 325.858 380.19 325.853 380.194 325.85C380.198 325.847 380.203 325.846 380.208 325.846C380.213 325.846 380.218 325.848 380.222 325.851C380.226 325.854 380.229 325.861 380.232 325.87C380.234 325.88 380.235 325.897 380.235 325.922Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.269 324.427C377.256 324.37 377.237 324.33 377.211 324.309C377.189 324.291 377.163 324.284 377.132 324.289C377.102 324.294 377.08 324.309 377.067 324.332C377.052 324.361 377.05 324.404 377.063 324.461C377.075 324.52 377.094 324.559 377.117 324.578C377.141 324.598 377.168 324.605 377.199 324.6C377.23 324.595 377.252 324.58 377.264 324.557C377.28 324.528 377.281 324.485 377.269 324.427ZM377.215 324.515C377.215 324.527 377.212 324.536 377.207 324.541C377.202 324.547 377.196 324.55 377.189 324.552C377.182 324.553 377.174 324.552 377.168 324.548C377.161 324.545 377.155 324.537 377.148 324.524C377.141 324.511 377.134 324.487 377.126 324.451C377.119 324.416 377.115 324.39 377.116 324.374C377.117 324.362 377.12 324.353 377.124 324.348C377.129 324.342 377.135 324.339 377.143 324.338C377.15 324.336 377.157 324.338 377.164 324.341C377.17 324.345 377.177 324.353 377.184 324.365C377.19 324.378 377.197 324.402 377.205 324.438C377.213 324.474 377.216 324.499 377.215 324.515Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.961 322.686C376.955 322.674 376.946 322.667 376.932 322.663C376.918 322.66 376.906 322.662 376.895 322.669C376.883 322.678 376.874 322.695 376.868 322.721C376.861 322.747 376.861 322.766 376.867 322.778C376.873 322.791 376.883 322.799 376.897 322.802C376.911 322.806 376.923 322.804 376.933 322.797C376.945 322.788 376.955 322.77 376.961 322.745C376.967 322.719 376.967 322.699 376.961 322.686ZM376.938 322.704C376.938 322.71 376.936 322.721 376.932 322.737C376.928 322.753 376.924 322.764 376.921 322.771C376.918 322.775 376.915 322.779 376.912 322.78C376.909 322.781 376.906 322.782 376.903 322.781C376.899 322.78 376.896 322.778 376.894 322.775C376.892 322.773 376.891 322.768 376.891 322.762C376.891 322.756 376.892 322.744 376.896 322.728C376.9 322.712 376.904 322.701 376.908 322.695C376.91 322.69 376.913 322.687 376.916 322.686C376.92 322.684 376.923 322.684 376.926 322.685C376.93 322.686 376.932 322.688 376.934 322.69C376.936 322.693 376.938 322.698 376.938 322.704Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.127 322.211C377.122 322.201 377.114 322.195 377.102 322.192C377.09 322.189 377.08 322.19 377.071 322.197C377.061 322.204 377.053 322.219 377.048 322.241C377.042 322.263 377.042 322.279 377.047 322.29C377.052 322.3 377.061 322.307 377.073 322.31C377.085 322.313 377.095 322.311 377.103 322.305C377.114 322.298 377.122 322.283 377.127 322.261C377.132 322.239 377.132 322.222 377.127 322.211ZM377.107 322.226C377.107 322.232 377.106 322.241 377.103 322.255C377.099 322.268 377.096 322.278 377.093 322.283C377.091 322.287 377.088 322.29 377.086 322.291C377.083 322.292 377.08 322.292 377.077 322.292C377.074 322.291 377.072 322.289 377.07 322.287C377.069 322.285 377.068 322.281 377.067 322.276C377.067 322.27 377.069 322.261 377.072 322.247C377.076 322.233 377.079 322.224 377.082 322.219C377.084 322.215 377.087 322.212 377.089 322.211C377.092 322.21 377.095 322.209 377.097 322.21C377.1 322.211 377.103 322.212 377.104 322.215C377.106 322.217 377.107 322.221 377.107 322.226Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.276 321.761C377.271 321.751 377.263 321.745 377.251 321.742C377.239 321.739 377.229 321.741 377.221 321.747C377.21 321.754 377.202 321.769 377.197 321.791C377.192 321.813 377.191 321.829 377.197 321.84C377.202 321.85 377.21 321.857 377.222 321.86C377.234 321.863 377.244 321.862 377.253 321.855C377.263 321.848 377.271 321.833 377.276 321.811C377.282 321.789 377.282 321.772 377.276 321.761ZM377.257 321.776C377.257 321.782 377.255 321.791 377.252 321.805C377.249 321.819 377.245 321.828 377.242 321.833C377.24 321.837 377.238 321.84 377.235 321.841C377.232 321.842 377.23 321.843 377.227 321.842C377.224 321.841 377.222 321.84 377.22 321.837C377.218 321.835 377.217 321.831 377.217 321.826C377.217 321.82 377.218 321.811 377.222 321.797C377.225 321.784 377.228 321.774 377.231 321.769C377.233 321.765 377.236 321.762 377.239 321.761C377.241 321.76 377.244 321.76 377.247 321.76C377.25 321.761 377.252 321.763 377.254 321.765C377.256 321.767 377.256 321.771 377.257 321.776Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.493 321.999C377.484 321.986 377.471 321.978 377.453 321.976C377.436 321.974 377.421 321.979 377.41 321.989C377.397 322.003 377.389 322.025 377.386 322.058C377.383 322.091 377.386 322.115 377.396 322.129C377.406 322.143 377.42 322.151 377.437 322.153C377.455 322.155 377.469 322.151 377.48 322.14C377.494 322.127 377.502 322.104 377.505 322.071C377.508 322.038 377.504 322.014 377.493 321.999ZM377.468 322.067C377.466 322.088 377.464 322.102 377.461 322.11C377.458 322.117 377.455 322.121 377.452 322.123C377.448 322.125 377.444 322.126 377.44 322.126C377.436 322.125 377.432 322.124 377.429 322.121C377.426 322.118 377.424 322.112 377.422 322.105C377.421 322.097 377.421 322.083 377.423 322.062C377.425 322.042 377.427 322.028 377.43 322.019C377.433 322.013 377.436 322.009 377.439 322.006C377.443 322.004 377.447 322.003 377.451 322.004C377.455 322.004 377.459 322.006 377.462 322.009C377.465 322.012 377.467 322.017 377.469 322.025C377.47 322.033 377.47 322.047 377.468 322.067Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.614 321.407C377.606 321.396 377.593 321.39 377.577 321.389C377.561 321.388 377.549 321.392 377.539 321.403C377.528 321.415 377.522 321.436 377.521 321.466C377.52 321.496 377.524 321.517 377.533 321.53C377.543 321.542 377.556 321.548 377.572 321.549C377.588 321.55 377.601 321.546 377.61 321.535C377.621 321.523 377.628 321.502 377.628 321.472C377.63 321.442 377.625 321.421 377.614 321.407ZM377.595 321.47C377.595 321.489 377.593 321.502 377.591 321.509C377.589 321.515 377.586 321.519 377.583 321.522C377.58 321.524 377.577 321.525 377.573 321.524C377.569 321.524 377.566 321.523 377.563 321.52C377.56 321.518 377.557 321.513 377.556 321.506C377.554 321.499 377.553 321.486 377.554 321.468C377.555 321.449 377.556 321.436 377.559 321.429C377.561 321.423 377.563 321.419 377.566 321.417C377.569 321.414 377.573 321.413 377.577 321.414C377.58 321.414 377.584 321.415 377.587 321.418C377.59 321.42 377.592 321.425 377.594 321.432C377.595 321.439 377.596 321.452 377.595 321.47Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.675 320.887C377.669 320.879 377.659 320.874 377.647 320.873C377.635 320.872 377.626 320.876 377.619 320.884C377.61 320.893 377.605 320.909 377.605 320.931C377.604 320.954 377.607 320.97 377.614 320.979C377.621 320.989 377.631 320.994 377.643 320.994C377.655 320.995 377.665 320.992 377.672 320.984C377.68 320.975 377.685 320.959 377.686 320.936C377.686 320.914 377.683 320.897 377.675 320.887ZM377.661 320.935C377.66 320.949 377.659 320.959 377.657 320.964C377.656 320.969 377.654 320.972 377.652 320.973C377.649 320.975 377.647 320.976 377.644 320.976C377.641 320.975 377.638 320.974 377.636 320.972C377.634 320.971 377.632 320.967 377.631 320.962C377.63 320.956 377.629 320.947 377.63 320.933C377.63 320.919 377.631 320.909 377.633 320.903C377.635 320.899 377.636 320.896 377.639 320.894C377.641 320.893 377.644 320.892 377.647 320.892C377.649 320.892 377.652 320.893 377.654 320.895C377.656 320.897 377.658 320.901 377.659 320.906C377.661 320.911 377.661 320.921 377.661 320.935Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.115 324.597C375.097 324.576 375.073 324.566 375.042 324.565C375.011 324.565 374.987 324.575 374.971 324.596C374.95 324.62 374.941 324.661 374.942 324.718C374.943 324.776 374.953 324.817 374.973 324.84C374.992 324.863 375.017 324.874 375.048 324.875C375.079 324.875 375.103 324.865 375.119 324.844C375.14 324.82 375.149 324.778 375.148 324.721C375.147 324.664 375.136 324.623 375.115 324.597ZM375.084 324.72C375.085 324.756 375.084 324.781 375.08 324.796C375.077 324.808 375.072 324.816 375.067 324.82C375.061 324.824 375.054 324.827 375.047 324.826C375.04 324.826 375.033 324.824 375.027 324.82C375.022 324.815 375.017 324.806 375.013 324.793C375.009 324.78 375.006 324.755 375.006 324.72C375.005 324.684 375.006 324.659 375.01 324.644C375.013 324.632 375.018 324.624 375.023 324.62C375.029 324.616 375.035 324.613 375.043 324.613C375.05 324.614 375.057 324.616 375.063 324.62C375.068 324.625 375.073 324.634 375.077 324.647C375.081 324.66 375.084 324.685 375.084 324.72Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.48 323.104C375.461 323.095 375.443 323.094 375.426 323.102C375.406 323.112 375.387 323.134 375.371 323.169C375.354 323.205 375.348 323.232 375.353 323.251C375.358 323.271 375.37 323.285 375.39 323.294C375.409 323.302 375.427 323.303 375.443 323.295C375.464 323.285 375.482 323.263 375.499 323.228C375.516 323.193 375.521 323.164 375.516 323.143C375.511 323.126 375.499 323.112 375.48 323.104ZM375.477 323.163C375.476 323.172 375.47 323.188 375.459 323.21C375.449 323.232 375.44 323.247 375.433 323.254C375.428 323.261 375.423 323.264 375.418 323.265C375.413 323.267 375.408 323.266 375.404 323.264C375.399 323.262 375.396 323.259 375.393 323.254C375.391 323.25 375.391 323.243 375.392 323.234C375.394 323.225 375.4 323.209 375.41 323.187C375.421 323.166 375.429 323.151 375.436 323.143C375.442 323.136 375.447 323.133 375.452 323.132C375.457 323.131 375.461 323.131 375.466 323.133C375.47 323.135 375.474 323.138 375.476 323.143C375.478 323.147 375.479 323.154 375.477 323.163Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.806 322.647C375.795 322.64 375.783 322.638 375.772 322.641C375.758 322.645 375.745 322.658 375.731 322.678C375.717 322.699 375.71 322.716 375.712 322.728C375.713 322.741 375.719 322.751 375.731 322.758C375.742 322.765 375.753 322.767 375.764 322.763C375.778 322.759 375.792 322.747 375.806 322.726C375.82 322.706 375.826 322.689 375.825 322.675C375.823 322.663 375.817 322.654 375.806 322.647ZM375.798 322.684C375.796 322.69 375.791 322.699 375.783 322.711C375.774 322.724 375.767 322.733 375.762 322.737C375.758 322.741 375.754 322.742 375.751 322.743C375.748 322.743 375.745 322.742 375.742 322.74C375.74 322.739 375.738 322.736 375.737 322.734C375.736 322.731 375.736 322.726 375.738 322.721C375.74 322.715 375.745 322.706 375.754 322.693C375.762 322.68 375.769 322.672 375.775 322.667C375.779 322.664 375.782 322.662 375.785 322.662C375.789 322.662 375.791 322.662 375.794 322.664C375.797 322.666 375.799 322.668 375.8 322.671C375.801 322.674 375.8 322.678 375.798 322.684Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.81 324.258C374.8 324.243 374.785 324.233 374.765 324.23C374.744 324.227 374.727 324.232 374.714 324.244C374.698 324.258 374.688 324.284 374.683 324.322C374.678 324.36 374.681 324.388 374.691 324.404C374.702 324.421 374.717 324.431 374.738 324.434C374.758 324.437 374.775 324.433 374.788 324.421C374.804 324.406 374.814 324.38 374.819 324.342C374.824 324.305 374.821 324.276 374.81 324.258ZM374.777 324.336C374.774 324.36 374.771 324.376 374.767 324.385C374.763 324.393 374.76 324.398 374.756 324.4C374.751 324.402 374.747 324.403 374.742 324.402C374.737 324.402 374.733 324.4 374.73 324.396C374.726 324.393 374.724 324.386 374.722 324.377C374.721 324.368 374.722 324.352 374.725 324.328C374.728 324.305 374.732 324.289 374.736 324.279C374.739 324.272 374.743 324.267 374.747 324.265C374.751 324.262 374.756 324.261 374.76 324.262C374.765 324.263 374.769 324.265 374.773 324.268C374.776 324.272 374.778 324.278 374.78 324.287C374.781 324.296 374.78 324.313 374.777 324.336Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.215 323.768L375.108 323.74L375.097 323.785L375.14 323.796L375.093 323.985L375.053 323.974L375.041 324.019L375.185 324.055L375.196 324.011L375.158 324.001L375.215 323.768Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.701 324.715L374.667 324.713L374.667 324.727L374.68 324.728L374.678 324.789L374.665 324.788L374.664 324.802L374.71 324.805L374.711 324.791L374.698 324.79L374.701 324.715Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.862 323.836L374.829 323.827L374.825 323.84L374.838 323.844L374.821 323.902L374.809 323.898L374.804 323.912L374.848 323.925L374.852 323.911L374.841 323.908L374.862 323.836Z",
    fill: "#59595B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 374.094,
    y: 318.663,
    width: 9.92151,
    height: 14.0513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 296.638,
    y1: 86.9076,
    x2: 320.032,
    y2: 46.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196181,
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 265.891,
    y1: 353.137,
    x2: 265.891,
    y2: 367.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 284.691,
    y1: 342.234,
    x2: 284.691,
    y2: 356.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 303.492,
    y1: 331.417,
    x2: 303.492,
    y2: 345.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 322.379,
    y1: 320.515,
    x2: 322.379,
    y2: 334.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 341.18,
    y1: 309.698,
    x2: 341.18,
    y2: 323.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 359.979,
    y1: 298.795,
    x2: 359.979,
    y2: 312.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 206.784,
    y1: 353.137,
    x2: 206.784,
    y2: 367.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 187.984,
    y1: 342.234,
    x2: 187.984,
    y2: 356.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 169.099,
    y1: 331.417,
    x2: 169.099,
    y2: 345.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 150.297,
    y1: 320.515,
    x2: 150.297,
    y2: 334.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 131.497,
    y1: 309.698,
    x2: 131.497,
    y2: 323.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 112.696,
    y1: 298.795,
    x2: 112.696,
    y2: 312.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 361.761,
    y1: 213.721,
    x2: 361.761,
    y2: 363.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 230.8,
    y1: 190.198,
    x2: 230.8,
    y2: 267.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 201.141,
    y1: 143.927,
    x2: 201.141,
    y2: 240.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 294.413,
    y1: 170.625,
    x2: 294.413,
    y2: 280.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 124.84,
    y1: 229.86,
    x2: 124.84,
    y2: 138.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 208.331,
    y1: 229.86,
    x2: 208.331,
    y2: 85.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 250.416,
    y1: 153.95,
    x2: 188.168,
    y2: 253.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 91.1267,
    y1: 357.772,
    x2: 91.1267,
    y2: 366.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 81.3834,
    y1: 346.441,
    x2: 81.3834,
    y2: 351.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 93.3157,
    y1: 279.994,
    x2: 67.5932,
    y2: 295.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 83.1567,
    y1: 285.125,
    x2: 35.1325,
    y2: 315.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 111.322,
    y1: 334.01,
    x2: 98.2088,
    y2: 315.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 107.802,
    y1: 331.949,
    x2: 94.6893,
    y2: 313.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 104.202,
    y1: 329.958,
    x2: 91.0559,
    y2: 311.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 100.719,
    y1: 327.908,
    x2: 87.5803,
    y2: 309.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 97.1617,
    y1: 325.923,
    x2: 84.0159,
    y2: 307.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 93.6412,
    y1: 323.863,
    x2: 80.4954,
    y2: 305.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 90.1217,
    y1: 321.802,
    x2: 76.9758,
    y2: 303.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 72.6272,
    y1: 291.911,
    x2: 39.6843,
    y2: 303.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 169.978,
    y1: 389.793,
    x2: 169.978,
    y2: 397.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 152.765,
    y1: 400.439,
    x2: 152.765,
    y2: 407.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 478.384,
    y1: 216.639,
    x2: 478.384,
    y2: 224.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 444.431,
    y1: 184.447,
    x2: 444.431,
    y2: 195.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 423.271,
    y1: 237.758,
    x2: 423.271,
    y2: 253.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 30.7766,
    y1: 302.916,
    x2: 30.7766,
    y2: 318.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 13.3491,
    y1: 292.271,
    x2: 13.3491,
    y2: 298.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 9.5,
    y1: 231.521,
    x2: 9.5,
    y2: 238.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 332.057,
    y1: 152.082,
    x2: 332.057,
    y2: 153.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 333.945,
    y1: 150.966,
    x2: 333.945,
    y2: 151.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 335.834,
    y1: 149.936,
    x2: 335.834,
    y2: 150.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 337.722,
    y1: 148.82,
    x2: 337.722,
    y2: 149.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 339.611,
    y1: 147.704,
    x2: 339.611,
    y2: 148.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 341.5,
    y1: 146.674,
    x2: 341.5,
    y2: 147.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 343.389,
    y1: 145.558,
    x2: 343.389,
    y2: 146.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 345.277,
    y1: 144.442,
    x2: 345.277,
    y2: 145.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 347.122,
    y1: 143.412,
    x2: 347.122,
    y2: 144.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 349.011,
    y1: 142.296,
    x2: 349.011,
    y2: 143.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 350.901,
    y1: 141.18,
    x2: 350.901,
    y2: 142.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 352.789,
    y1: 140.149,
    x2: 352.789,
    y2: 141.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 330.899,
    y1: 150.451,
    x2: 330.899,
    y2: 152.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 329.481,
    y1: 148.991,
    x2: 329.481,
    y2: 151.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 327.979,
    y1: 147.446,
    x2: 327.979,
    y2: 150.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 325.147,
    y1: 147.017,
    x2: 325.147,
    y2: 149.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 327.894,
    y1: 145.472,
    x2: 327.894,
    y2: 147.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 330.727,
    y1: 143.841,
    x2: 330.727,
    y2: 145.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 340.255,
    y1: 138.346,
    x2: 340.255,
    y2: 140.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 343.99,
    y1: 135.599,
    x2: 343.99,
    y2: 138.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 335.491,
    y1: 139.892,
    x2: 335.491,
    y2: 144.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 333.517,
    y1: 149.077,
    x2: 333.517,
    y2: 150.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 332.487,
    y1: 147.618,
    x2: 332.487,
    y2: 149.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 331.371,
    y1: 146.073,
    x2: 331.371,
    y2: 147.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 333.774,
    y1: 144.699,
    x2: 333.774,
    y2: 146.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 336.221,
    y1: 143.326,
    x2: 336.221,
    y2: 144.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 338.624,
    y1: 141.952,
    x2: 338.624,
    y2: 143.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 341.071,
    y1: 140.579,
    x2: 341.071,
    y2: 142.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 343.475,
    y1: 139.119,
    x2: 343.475,
    y2: 140.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 346.608,
    y1: 136.973,
    x2: 346.608,
    y2: 139.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 334.89,
    y1: 146.244,
    x2: 334.89,
    y2: 147.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 337.293,
    y1: 144.785,
    x2: 337.293,
    y2: 146.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 339.698,
    y1: 143.411,
    x2: 339.698,
    y2: 145.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 342.102,
    y1: 142.038,
    x2: 342.102,
    y2: 143.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 344.505,
    y1: 140.664,
    x2: 344.505,
    y2: 142.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 348.025,
    y1: 138.003,
    x2: 348.025,
    y2: 140.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 335.92,
    y1: 147.704,
    x2: 335.92,
    y2: 149.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 338.324,
    y1: 146.33,
    x2: 338.324,
    y2: 147.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 340.727,
    y1: 144.957,
    x2: 340.727,
    y2: 146.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 343.131,
    y1: 143.497,
    x2: 343.131,
    y2: 145.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 345.536,
    y1: 142.124,
    x2: 345.536,
    y2: 143.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 347.982,
    y1: 140.75,
    x2: 347.982,
    y2: 142.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 350.643,
    y1: 139.033,
    x2: 350.643,
    y2: 140.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 330.255,
    y1: 135.256,
    x2: 330.255,
    y2: 143.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 56.5,
    y1: 253.521,
    x2: 56.5,
    y2: 264.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 388.336,
    y1: 399.5,
    x2: 388.336,
    y2: 406.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 404.305,
    y1: 389.885,
    x2: 404.305,
    y2: 396.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManagementHero);
export default __webpack_public_path__ + "static/media/data_management_hero.8965a5b075cf5e592cde1b7142f36fa2.svg";
export { ForwardRef as ReactComponent };